import React from 'react';
import type { IconProps } from '../types';

export const ToolLayout = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-layout"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(0.5, 4)"
        strokeLinecap="round"
      >
        <g
          id="Group-3"
          transform="translate(0, 0)"
          stroke="currentColor"
          strokeWidth="1.25"
        >
          <path
            d="M5.45696821e-12,9.49450549 L5.45696821e-12,17.3947362 C5.45710348e-12,18.4993057 0.8954305,19.3947362 2,19.3947362 L13.2443085,19.3947362 L13.2443085,19.3947362"
            id="Path-3"
          ></path>
          <path
            d="M9.49450549,0 L9.49450549,4.91369247 L9.49450549,6 C9.49450549,7.1045695 10.389936,8 11.4945055,8 L19.195248,8 L19.195248,8"
            id="Path-3"
            transform="translate(14.3449, 4) rotate(180) translate(-14.3449, -4)"
          ></path>
          <path
            d="M0.0997440877,-0.0997440877 L0.0997440877,7.80048659 C0.0997440877,8.90505609 0.995174588,9.80048659 2.09974409,9.80048659 L9.80048659,9.80048659 L9.80048659,9.80048659"
            id="Path-3"
            transform="translate(4.9501, 4.8504) rotate(90) translate(-4.9501, -4.8504)"
          ></path>
        </g>
        <g
          id="Group-10"
          opacity="0.550000012"
          transform="translate(2, 2)"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <line
            x1="7.5"
            y1="14.5"
            x2="7.5"
            y2="0.5"
            id="Line-2"
          ></line>
          <line
            x1="7"
            y1="14"
            x2="7"
            y2="1"
            id="Line-2"
            transform="translate(7, 7.5) rotate(90) translate(-7, -7.5)"
          ></line>
        </g>
        <g
          id="gear"
          transform="translate(21.0876, 17.2796) rotate(-20) translate(-21.0876, -17.2796)translate(15.9634, 11.5127)"
          stroke="#348CFD"
          strokeLinejoin="round"
          strokeWidth="1.25"
        >
          <circle
            id="Oval"
            cx="5.12378058"
            cy="5.76719178"
            r="1.28158482"
          ></circle>
          <path
            d="M6.21361819,0.80762797 L6.59086967,2.04907966 C6.72061095,2.47639719 7.15892721,2.73042581 7.59419808,2.63056421 L8.85259487,2.33893009 C9.34216301,2.22858155 9.84650092,2.45011894 10.0964357,2.88530436 C10.3463705,3.32048979 10.2835655,3.86774756 9.94154064,4.23499782 L9.06128718,5.18481538 C8.75980718,5.51248709 8.75980718,6.0165454 9.06128718,6.3442171 L9.94154064,7.29403466 C10.2835655,7.66128493 10.3463705,8.2085427 10.0964357,8.64372812 C9.84650092,9.07891354 9.34216301,9.30045094 8.85259487,9.1901024 L7.59419808,8.89846827 C7.15663131,8.79632613 6.71524652,9.05279063 6.58730228,9.48352022 L6.2100508,10.7249719 C6.0649735,11.2053044 5.62242271,11.5339347 5.12065911,11.5339347 C4.61889551,11.5339347 4.17634472,11.2053044 4.03126742,10.7249719 L3.65669148,9.48352022 C3.52807698,9.05567912 3.08963152,8.80095947 2.65425492,8.90114382 L1.39585813,9.19277794 C0.90628999,9.30312648 0.401952083,9.08158909 0.152017275,8.64640366 C-0.0979175321,8.21121824 -0.035112502,7.66396047 0.306912358,7.29671021 L1.18716582,6.34689264 C1.48864582,6.01922094 1.48864582,5.51516263 1.18716582,5.18749093 L0.306912358,4.23767336 C-0.035112502,3.8704231 -0.0979175321,3.32316533 0.152017275,2.88797991 C0.401952083,2.45279448 0.90628999,2.23125709 1.39585813,2.34160563 L2.65425492,2.63323975 C3.08937078,2.73350334 3.52770594,2.47923776 3.65669148,2.0517552 L4.03483481,0.810303513 C4.17932126,0.32979188 4.62146882,0.000617032116 5.12323309,0 C5.62499736,-0.000615299293 6.06795204,0.327472644 6.21361819,0.80762797 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ToolClickSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M18.7855 10.7063C19.0677 8.68223 18.754 6.39013 17.3334 4.86666C15.7881 3.20953 13.3171 2.78346 11.098 3.09398C9.51269 3.31581 7.93737 4.03721 6.63198 5.25454C5.24718 6.54592 4.39791 8.17926 4.11016 9.84527C3.74697 11.9481 4.27832 14.1031 5.75643 15.6882C7.30168 17.3453 9.54033 18.0136 11.7594 17.7031"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.0003 18.562L15.0714 12.3038C15.0714 12.1629 15.1293 12.0689 15.2452 12.0219C15.3663 11.9749 15.4769 12.0036 15.577 12.108L19.8981 16.502C20.0034 16.6169 20.0271 16.7318 19.9692 16.8467C19.9165 16.9615 19.8164 17.0216 19.669 17.0268L17.9627 17.0973L19.353 20.2929C19.3899 20.366 19.3951 20.4391 19.3688 20.5123C19.3477 20.5854 19.303 20.6376 19.2345 20.6689L18.4445 20.9822C18.3708 21.0083 18.2997 21.0057 18.2312 20.9744C18.1628 20.943 18.1128 20.8908 18.0812 20.8177L16.754 17.5673L15.5533 18.7656C15.4532 18.8648 15.3347 18.8935 15.1978 18.8518C15.0609 18.81 14.995 18.7134 15.0003 18.562Z"
      fill="currentColor"
    />
  </svg>
);

export const ToolLength = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-length"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="ruler"
        transform="translate(2, 2.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect
          id="Rectangle"
          strokeWidth="1.5"
          transform="translate(11.5003, 11.5005) rotate(-45.001) translate(-11.5003, -11.5005)"
          x="-0.874220029"
          y="7.6109894"
          width="24.749"
          height="7.779"
          rx="1"
        ></rect>
        <line
          x1="5.11737261"
          y1="12.3844231"
          x2="7.13237261"
          y2="14.3684231"
          id="Path"
        ></line>
        <line
          x1="7.68571234"
          y1="9.81508336"
          x2="10.1857123"
          y2="12.3150834"
          id="Path"
        ></line>
        <line
          x1="10.1225521"
          y1="7.37924362"
          x2="11.8725521"
          y2="9.12924362"
          id="Path"
        ></line>
        <line
          x1="12.5583918"
          y1="4.94240389"
          x2="15.0583918"
          y2="7.44240389"
          id="Path"
        ></line>
        <line
          x1="15.1127315"
          y1="2.38806416"
          x2="17.1277315"
          y2="4.37406416"
          id="Path"
        ></line>
        <line
          x1="2.56403288"
          y1="14.9377628"
          x2="5.06403288"
          y2="17.4377628"
          id="Path"
        ></line>
      </g>
    </g>
  </svg>
);

export const ToolTAGT = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-ta-gt"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        x="0"
        y="0"
        width="28"
        height="28"
      />
      <text
        x="14"
        y="13"
        fill="currentColor"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="11"
        fontWeight="800"
        textAnchor="middle"
      >
        TA
      </text>
      <text
        x="14"
        y="23"
        fill="currentColor"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="11"
        fontWeight="800"
        textAnchor="middle"
      >
        GT
      </text>
    </g>
  </svg>
);

export const ToolSpineLabeling = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-spine-labeling"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M15 3.5C10.5 5.7 18.1 8.4 12 11.2C6.5 13.8 14.9 16.3 10.8 19.1C8.4 20.8 10 23 14.2 24.5"
        strokeWidth="1.8"
      />
      <path
        d="M8 7.5H18"
        strokeWidth="1.2"
      />
      <path
        d="M7 13.2H17"
        strokeWidth="1.2"
      />
      <path
        d="M7.8 19H17.8"
        strokeWidth="1.2"
      />
    </g>
  </svg>
);

export const Tool3DRotate = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-3d-rotate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      />
      <g
        id="Group"
        transform="translate(4, 3)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <g id="group">
          <polyline
            id="Path"
            points="6 21.996 8.5 19.998 6 17.996"
          />
          <path
            d="M8.5,19.998 C5.038,20.652 1,18.498 0,14.998"
            id="Path"
          />
          <polyline
            id="Path"
            points="14 0 11.5 1.998 14 4"
          />
          <path
            d="M11.5,1.998 C14.962,1.344 19,3.498 20,6.998"
            id="Path"
          />
        </g>
        <g
          id="3d"
          transform="translate(5, 5.75)"
        >
          <polygon
            id="Path"
            points="5 0 0 2.1875 5 4.375 10 2.1875"
          />
          <polyline
            id="Path"
            points="0 2.1875 0 8.125 5 10.3125 10 8.125 10 2.1875"
          />
          <line
            x1="5"
            y1="4.375"
            x2="5"
            y2="10.3125"
            id="Path"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ToolAngle = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-angle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      />
      <g
        id="Group-6"
        transform="translate(2.4559, 6)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      >
        <line
          x1="2.5"
          y1="14.5"
          x2="20.6875"
          y2="14.4375"
          id="Line-4"
        />
        <line
          x1="1"
          y1="13.3775095"
          x2="13.0650095"
          y2="1.3125"
          id="Line-4"
          transform="translate(7.0325, 7.345) rotate(-10) translate(-7.0325, -7.345)"
        />
      </g>
      <path
        d="M19.3390559,17.0930296 C19.4124327,13.0930296 17.4130821,11.0930296 13.3410041,11.0930296"
        id="Path-4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="1,2.7"
        transform="translate(16.341, 14.093) rotate(12) translate(-16.341, -14.093)"
      />
    </g>
  </svg>
);

export const ToolAnnotate = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-annotate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      />
      <g
        id="Group"
        transform="translate(4, 3.3899)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <polyline
          id="Path"
          points="8.59335038 20.2520716 -6.1284311e-14 20.2520716 -6.1284311e-14 11.6587212"
        />
        <line
          x1="-4.08562073e-14"
          y1="20.2520716"
          x2="19.6419437"
          y2="0.610127877"
          id="Path"
        />
      </g>
    </g>
  </svg>
);

export const ToolBidirectional = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-bidirectional"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="group"
        transform="translate(2.5, 2.5)"
        stroke="currentColor"
      >
        <g
          id="Group-5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M19.7288691,-0.335661423 C20.1766848,-0.335701004 20.6245155,-0.164922663 20.9661629,0.176604012 L22.785192,1.99444856 C23.0988548,2.30800052 23.2685446,2.7110041 23.2944775,3.12134197 C23.3217954,3.55359523 23.188997,3.99381095 22.8972982,4.34658876 L4.09686309,23.1566959 C3.72728287,23.5261645 3.24294798,23.7108988 2.75861309,23.7108988 C2.2742782,23.7108988 1.78994331,23.5261645 1.420283,23.1566158 L-0.19579707,21.5405357 C-0.56526569,21.1709555 -0.75,20.6866206 -0.75,20.2022857 C-0.75,19.7179508 -0.56526569,19.2336159 -0.195713448,18.8639521 L18.4915869,0.176901703 C18.833253,-0.16476434 19.2810535,-0.335621842 19.7288691,-0.335661423 Z"
            id="Path"
            strokeWidth="1.5"
          ></path>
          <line
            x1="4.1448988"
            y1="18.9142857"
            x2="5.71632738"
            y2="20.4765714"
            id="Path"
          ></line>
          <line
            x1="6.5688988"
            y1="16.4902857"
            x2="8.14261309"
            y2="18.0502857"
            id="Path"
          ></line>
          <line
            x1="8.9928988"
            y1="14.0662857"
            x2="10.5654702"
            y2="15.6274286"
            id="Path"
          ></line>
          <line
            x1="11.4168988"
            y1="11.6422857"
            x2="12.9917559"
            y2="13.2011429"
            id="Path"
          ></line>
          <line
            x1="13.8408988"
            y1="9.21714286"
            x2="15.4066131"
            y2="10.7874286"
            id="Path"
          ></line>
          <line
            x1="16.1345622"
            y1="6.9234795"
            x2="17.7002765"
            y2="8.49376521"
            id="Path"
          ></line>
          <line
            x1="18.5589283"
            y1="4.49911339"
            x2="20.1246426"
            y2="6.0693991"
            id="Path"
          ></line>
        </g>
        <path
          d="M9.21155442,3 L3.86096848,3 C3.30868373,3 2.86096848,3.44771525 2.86096848,4 L2.86096848,6.5 C2.86096848,7.05228475 3.30868373,7.5 3.86096848,7.5 L9.21155442,7.5 L9.21155442,7.5"
          id="Path-6"
          strokeWidth="1.5"
          transform="translate(6.0363, 5.25) rotate(-315) translate(-6.0363, -5.25)"
        ></path>
        <path
          d="M21.0115544,14.7862614 L15.6609685,14.7862614 C15.1086837,14.7862614 14.6609685,15.2339767 14.6609685,15.7862614 L14.6609685,18.2862614 C14.6609685,18.8385462 15.1086837,19.2862614 15.6609685,19.2862614 L21.0115544,19.2862614 L21.0115544,19.2862614"
          id="Path-6"
          strokeWidth="1.5"
          transform="translate(17.8363, 17.0363) rotate(-135) translate(-17.8363, -17.0363)"
        ></path>
      </g>
    </g>
  </svg>
);

export const ToolCalibrate = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-calibrate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="calibrate"
        transform="translate(2.5, 16.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      >
        <polyline
          id="Path"
          points="20 6 23 3 20 0"
        ></polyline>
        <line
          x1="1"
          y1="3"
          x2="22"
          y2="3"
          id="Path"
        ></line>
        <polyline
          id="Path"
          points="3 6 0 3 3 0"
        ></polyline>
      </g>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.25"
        x="2"
        y="5"
        width="24"
        height="6"
        rx="2"
      ></rect>
      <line
        x1="6.5"
        y1="10.5"
        x2="6.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
      <line
        x1="9.5"
        y1="10.5"
        x2="9.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
      <line
        x1="12.5"
        y1="10.5"
        x2="12.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
      <line
        x1="15.5"
        y1="10.5"
        x2="15.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
      <line
        x1="18.5"
        y1="10.5"
        x2="18.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
      <line
        x1="21.5"
        y1="10.5"
        x2="21.5"
        y2="8.5"
        id="Line-5"
        stroke="currentColor"
        strokeLinecap="round"
      ></line>
    </g>
  </svg>
);

export const ToolCapture = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M8.64381845,8.55555556 C9.05021618,8.5340019 9.43897503,8.38261884 9.75292956,8.12366667 L11.6057073,6.43188889 C11.919523,6.17269999 12.308363,6.02128533 12.7148185,6 L15.6179296,6 C16.0208348,6.0234362 16.4057732,6.17472593 16.7168185,6.43188889 L18.5695962,8.12366667 C18.8835508,8.38261884 19.2723096,8.5340019 19.6787073,8.55555556 L23.1057073,8.55555556 C24.2042675,8.66849081 25.0354336,9.60050503 25.0225258,10.7047778 L25.0225258,19.4166667 C25.0225258,20.4752124 24.1642531,21.3333333 23.1057073,21.3333333 L5.21681845,21.3333333 C4.15827268,21.3333333 3.3,20.4752124 3.3,19.4166667 L3.3,10.7047778 C3.28709219,9.60050503 4.11825826,8.66849081 5.21681845,8.55555556 L8.64381845,8.55555556 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="14.1612629"
        cy="13.9861111"
        r="3.51388889"
      ></circle>
      <path
        d="M21.8279296,11.4305556 C22.0043539,11.4305556 22.147374,11.5735757 22.147374,11.75 C22.147374,11.9264243 22.0043539,12.0694444 21.8279296,12.0694444 C21.6515053,12.0694444 21.5084851,11.9264243 21.5084851,11.75 C21.5084851,11.5735757 21.6515053,11.4305556 21.8279296,11.4305556"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolCine = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-cine"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="14"
        cy="13.9990833"
        r="10.5416667"
      ></circle>
      <path
        d="M11.5416667,11.7236444 L17.3036401,14.0295711 L11.5416667,16.9105578 L11.5416667,11.7236444 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);

export const ToolCircle = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-circle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="14"
        cy="14"
        r="9.5"
      ></circle>
    </g>
  </svg>
);

export const ToolGlenoidTrack = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="5 8 90 88"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="tool-glenoid-track"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
      d="m29.652 36.543c0.71875 2.3633-0.13672 5.125-2.5391 8.2227-1.3203 1.7031-2.0469 3.8906-2.0469 6.1602v39.699c0 0.86328-0.69922 1.5625-1.5625 1.5625-0.86328 0-1.5625-0.69922-1.5625-1.5625v-39.699c0-2.9609 0.96094-5.8281 2.7031-8.0781 1.7188-2.2148 2.4141-4.082 2.0156-5.3984-0.39844-1.3164-1.8711-1.8594-1.8867-1.8633-0.63672-0.21484-1.0664-0.8125-1.0664-1.4844-0.015625-0.60547-0.35547-3.7344-5.5039-3.7344-4.0938 0.058593-7.2695 3.3672-7.2695 7.3867v0.64062c0 1.5039 0.44141 2.9648 1.2773 4.2188 1.4766 2.2109 2.2539 4.7891 2.2539 7.4492v40.562c0 0.86328-0.69922 1.5625-1.5625 1.5625-0.86328 0-1.5625-0.69922-1.5625-1.5625v-40.562c0-2.043-0.59766-4.0195-1.7305-5.7148-1.1797-1.7695-1.8008-3.8281-1.8008-5.9492v-0.64063c0-5.7109 4.5547-10.43 10.156-10.512 6.1328 0 8.3008 3.3828 8.7656 5.8242 0.95703 0.53906 2.3594 1.6133 2.9219 3.4727zm59.727-16.938c-1.8945 0.94922-7.0078 2.957-16.594 3.5273 3.0117 6.4336 3.5039 18.137 3.5039 25.098 0 1.8477-0.43359 6.1719-0.89062 10.754-0.42969 4.3047-0.875 8.7539-0.875 10.441 0 3.2461-1.625 12.156-6.8594 12.156-2.75 0-7.8047-2.8516-14.129-6.582-1.75-1.0352-3.2656-1.9297-4.2344-2.4141-3.5039-1.75-4.7031-8-5.582-12.562-0.19531-1.0117-0.36328-1.9062-0.53516-2.582-0.62891-2.5234-2.3672-4.9414-4.207-7.5-3.0156-4.1953-6.4375-8.9531-6.4375-15.844 0-8.6289 10.484-8.6289 13.926-8.6289 1.7305 0 3.7578-1.1836 6.1055-2.5547 0.13672-0.078124 0.29688-0.16797 0.4375-0.25-4.9961-0.24219-9.918-0.28516-15.301 0.60547-1.4805 0.24609-2.7891 0.37109-3.9336 0.37109-2.8828 0-4.6992-0.78906-5.5195-2.3789-1.043-2.0312 0-4.9102 2.793-7.7031 4.1133-4.1133 13.227-2.8867 22.871-1.5898 4.332 0.58203 8.4258 1.1328 11.789 1.1328 10.09 0 20.395-5.082 20.5-5.1328 0.21484-0.10547 0.45312-0.16406 0.69922-0.16406 2.5859 0 4.4844 1.4961 5.0781 4.0039 0.63281 2.6797-0.37109 6.668-2.6133 7.7891zm-20.125 3.6523c-0.59766 0.011719-1.1406 0.042969-1.7695 0.042969-2.9141 0-5.6758-0.14062-8.375-0.29297-1.7969 0.77734-3.4062 1.707-4.957 2.6133-2.7422 1.5977-5.1055 2.9805-7.6836 2.9805-5.3438 0-10.801 0.65234-10.801 5.5039 0 5.8828 2.9727 10.02 5.8477 14.02 2.0195 2.8125 3.9258 5.4648 4.7031 8.5625 0.17969 0.71875 0.36719 1.6719 0.57422 2.7539 0.62109 3.2461 1.7852 9.2969 3.9062 10.355 1.0156 0.50781 2.5938 1.4375 4.4258 2.5195 3.8984 2.2969 10.426 6.1484 12.539 6.1484 1.8516 0 3.7344-5.2539 3.7344-9.0312 0-1.8477 0.43359-6.1719 0.89062-10.754 0.42969-4.3047 0.875-8.7539 0.875-10.441 0-12.059-1.4609-21.234-3.9102-24.977zm19.68-10.789c-0.24219-0.94922-0.77344-1.4297-1.6914-1.5156-2.0195 0.95703-11.676 5.2812-21.523 5.2812-3.5742 0-7.7656-0.56641-12.207-1.1602-4.2891-0.57812-8.8828-1.1914-12.703-1.1914-3.3672 0-6.1328 0.48047-7.5469 1.8945-1.8594 1.8594-2.4844 3.5508-2.2227 4.0625 0.22656 0.44141 1.8047 1.0898 6.1602 0.35547 7.168-1.1914 13.426-0.81641 20.047-0.42187 3.2852 0.19531 6.6836 0.39844 10.234 0.39844 12.773 0 18.918-2.5742 20.496-3.3672 0.50781-0.28125 1.4297-2.4766 0.95313-4.3438zm-75.82 7.5039c0-2.9023 2.9297-5.418 5.832-6.6211 2.4492-1.0156 4.5117-0.94141 5.6641 0.21484 1.3086 1.3047 0.92188 2.7695 0.66406 3.7344-0.082032 0.3125-0.17969 0.65234-0.21094 1.0234-0.015625 0.21484 0.0625 0.62109 0.13672 0.98047 0.19531 0.97656 0.49609 2.4531-0.58984 3.5352-0.85938 0.85938-2.25 1.1836-3.7461 1.1836-1.7227 0-3.582-0.43359-4.9102-0.98438-1.8867-0.78125-2.8438-1.8164-2.8438-3.0703zm3.1562-0.27734c0.54297 0.40625 2.1914 1.0547 4.0273 1.1875 1.375 0.10938 2-0.15234 2.1055-0.25-0.10156 0.054688-0.20312-0.39844-0.26562-0.70703-0.11328-0.55859-0.23828-1.1914-0.1875-1.8398 0.042969-0.57031 0.17578-1.0938 0.30469-1.582 0.066406-0.25391 0.16797-0.63672 0.15625-0.75781-0.25781-0.078125-1.7188 0.019531-3.582 1.1641-1.3906 0.85547-2.3711 1.9332-2.5547 2.7812z"
    />
  </svg>
);

export const ToolLiverFatAssessment = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="5 14 90 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="tool-liver-fat-assessment"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
      d="m25.453 18.098c10.984-2.043 16.762-0.91016 21.238 0.75781 4.4766 1.6719 6.875 3.4531 11.969 3.2188 2.6914-0.12109 5.8828-0.48828 9.2734-0.85938 3.3633-0.36719 6.9023-0.73047 10.191-0.82812 3.2617-0.09375 6.4141 0.070312 8.9531 0.83594 2.5625 0.77344 4.7539 2.2461 5.582 4.9023 0.73047 2.3359 0.53906 4.3086-0.32812 6.0117-0.82812 1.625-2.2031 2.8711-3.5508 3.9297-1.4531 1.1406-2.7422 1.9844-4.0195 3.0977-1.207 1.0547-2.1289 2.1445-2.6328 3.4492-1.3477 3.5117-4.0117 7.2109-7.4922 10.168-3.4844 2.957-7.8789 5.2422-12.742 5.7852-0.49609 0.054688-0.96094 0.10156-1.3945 0.14844v20.535c0 2.3477-1.9023 4.25-4.25 4.25s-4.25-1.9023-4.25-4.25v-14.773c-0.77734 0.80859-1.6289 1.5742-2.5117 2.2656-1.5469 1.2188-3.2148 2.2617-4.7461 3.0039-1.4766 0.71875-3.0117 1.2539-4.2422 1.2539-1.4453 0-2.293 0.28125-3.4453 1.0156-0.625 0.39844-1.3242 0.92188-2.2539 1.6289-0.91797 0.69922-2.0273 1.5547-3.418 2.5703-1.2422 0.90234-2.4453 1.418-3.6133 1.4922-1.207 0.078125-2.2188-0.32812-3.0039-0.97656-0.63672-0.53125-1.1094-1.2109-1.457-1.9141-0.24609 0.24219-0.49219 0.48828-0.75 0.74609l-0.054688 0.054688-0.0625 0.050781c-1.082 0.87109-2.3008 1.9922-3.7617 3.2266-1.3945 1.1797-2.9375 2.4023-4.4141 3.2188-1.375 0.75781-3.1875 1.457-4.8398 0.72656-1.75-0.77344-2.4844-2.7344-2.6914-5.1367-0.51172-5.8633-0.25391-9.457 0-12.504 0.25-3.0039 0.48438-5.3555 0.007813-8.9258-0.5-3.75-1.543-12.125 0.33984-20.105 0.94531-4.0117 2.6445-8 5.5859-11.262 2.9609-3.2852 7.1094-5.75 12.785-6.8086zm32.047 40.914c-0.96484 0.085937-1.6797 0.14453-2.2305 0.19141-0.074219 0.28125-0.16406 0.55859-0.26953 0.83203v19.215c0 0.69141 0.55859 1.25 1.25 1.25s1.25-0.55859 1.25-1.25zm-11.859-37.344c-3.8984-1.457-9.1211-2.5742-19.637-0.61719-5.0703 0.94141-8.6133 3.0977-11.105 5.8633-2.5117 2.7852-4.0312 6.2656-4.8984 9.9414-1.7422 7.3906-0.78516 15.273-0.28516 19.02 0.52344 3.9297 0.25781 6.5781 0.007812 9.5742-0.24609 2.9531-0.48828 6.3594 0 11.996 0.19141 2.1953 0.77734 2.5898 0.91406 2.6484 0.23438 0.10547 0.875 0.11328 2.1758-0.60547 1.1992-0.66406 2.5547-1.7188 3.9297-2.8828 1.2812-1.082 2.6719-2.3438 3.75-3.2188 0.83984-0.83984 1.6211-1.6172 2.3555-2.3438 0.0625-0.078125 0.13672-0.14844 0.21484-0.21484 3.3594-3.3086 5.7812-5.4648 8.9727-7.2383 3.918-2.1797 8.9609-3.7578 18.277-6.457 0.96094-0.27734 1.5977-0.45703 2.1523-0.58203-0.082032-1.3203-0.30078-3.207-0.55078-5.5312-0.3125-2.8945-0.66016-6.3438-0.78906-9.8398-0.125-3.4844-0.035156-7.082 0.55469-10.25 0.42578-2.2852 1.1328-4.457 2.293-6.2227-3.1992-0.66406-5.6328-2.0352-8.332-3.0391zm5.5078 38.348c-9.4141 2.7266-14.094 4.2148-17.656 6.1953-2.7109 1.5039-4.7969 3.3047-7.8555 6.2969 0.21094 0.78906 0.57812 1.5234 1.0469 1.9141 0.25 0.20703 0.52344 0.31641 0.89453 0.29297 0.41406-0.027344 1.082-0.23047 2.0391-0.92578 1.3594-0.98828 2.4336-1.8203 3.3633-2.5273 0.91406-0.69922 1.7148-1.3008 2.4648-1.7773 1.5977-1.0156 3-1.4844 5.0547-1.4844 0.51953 0 1.5469-0.27734 2.9297-0.94922 1.3281-0.64453 2.8164-1.5742 4.2031-2.668 1.3945-1.0938 2.6445-2.3242 3.5312-3.5625 0.24219-0.33984 0.45313-0.66797 0.62891-0.98828-0.19531 0.054688-0.41016 0.11328-0.64453 0.18359zm27.062-36.629c-3.1523 0.089843-6.5781 0.44141-9.9492 0.8125-3.3438 0.36328-6.6523 0.74609-9.4648 0.875-0.4375 0.019531-0.85938 0.023437-1.2695 0.015625-0.003906 0.003906-0.003906 0.007812-0.007813 0.011718-1.4023 1.3008-2.3516 3.4883-2.8906 6.3789-0.53125 2.8594-0.62891 6.2031-0.50391 9.5898 0.12109 3.3789 0.46094 6.7422 0.77344 9.6289 0.22656 2.1016 0.44922 4.0234 0.54687 5.4766 1.1953-0.097656 2.9727-0.24219 6.1172-0.59375 4.1406-0.45703 7.9961-2.4219 11.133-5.0898 3.1484-2.668 5.4844-5.9688 6.6328-8.957 0.75-1.9453 2.0781-3.418 3.4609-4.6289 1.3164-1.1523 2.9688-2.2773 4.1406-3.1992 1.2773-1.0039 2.2109-1.918 2.7305-2.9297 0.47656-0.9375 0.66016-2.0898 0.13672-3.7539-0.41797-1.3438-1.5391-2.3086-3.5859-2.9258-2.0703-0.625-4.8281-0.80469-8-0.71094z"
    />
  </svg>
);

export const ToolPIRADS = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-pirads"
      fill="currentColor"
      stroke="currentColor"
      strokeLinejoin="round"
    >
      <path
        strokeWidth="2.5"
        d="M48.67 97.4C48.67 97.69 48.44 97.93 48.15 97.94C47.86 97.94 47.63 97.71 47.63 97.43C47.57 92.78 46.76 92.52 45.1 91.98C43.95 91.61 42.45 91.12 40.58 89.48C37.27 86.58 33.91 82.02 32.14 77.12C30.7 73.12 30.32 68.89 31.87 65.13C32.68 63.16 31.7 62.45 30.49 61.56C29.99 61.19 29.45 60.8 28.95 60.3L28.66 60.01C20.4 51.78 12.66 44.07 13.24 30.94C13.24 30.93 13.24 30.91 13.24 30.9L13.24 30.89C13.66 21.65 17.87 14.81 24.06 10.1C31.35 4.56 41.38 2.01 51.14 2C58.95 1.99 66.74 3.85 73.07 7.79C78.73 11.31 83.22 16.48 85.54 23.45C85.87 24.44 86.13 25.43 86.33 26.41C86.41 26.79 86.48 27.17 86.53 27.56C87.34 32.92 86.23 38.05 84.02 42.83C81.26 48.78 76.79 54.18 72.16 58.81C71.25 59.72 70.53 60.4 69.97 60.93C68.94 61.92 68.48 62.35 68.38 62.68C68.32 62.9 68.4 63.22 68.56 63.78C68.61 63.98 68.67 64.21 68.74 64.48C68.8 64.68 68.85 64.89 68.89 65.1C69.05 65.86 69.22 66.84 69.35 68.16L69.35 68.16C69.97 73.73 68.84 78.34 66.81 82.05C64.17 86.87 60.02 90.17 56.2 92.17C55.96 92.3 55.7 92.42 55.48 92.52C54.66 92.91 54.47 93 54.27 94.48C54.21 94.92 54.17 95.4 54.16 95.88C54.14 96.41 54.16 96.95 54.18 97.44C54.2 97.73 53.98 97.98 53.69 98C53.4 98.02 53.16 97.8 53.14 97.51C53.11 96.99 53.1 96.42 53.12 95.86C53.13 95.34 53.17 94.83 53.23 94.36C53.51 92.31 53.8 92.17 55.04 91.58C55.23 91.49 55.44 91.39 55.73 91.24C59.39 89.33 63.38 86.16 65.89 81.56C67.83 78.02 68.91 73.62 68.31 68.28L68.3 68.27C68.15 66.67 67.93 65.58 67.74 64.81C67.19 62.87 65.52 61.74 63.52 61.29C62.42 61.05 61.23 61.01 60.04 61.16C58.86 61.31 57.7 61.65 56.69 62.15C54.69 63.15 53.24 64.81 53.3 66.99C53.37 67.26 53.46 67.54 53.55 67.82C54.35 70.2 54.24 73.73 54.12 77.68C54.1 78.12 54.09 78.56 54.07 79.01C53.96 83.06 53.48 86.16 53.04 89.02C52.6 91.84 52.2 94.43 52.23 97.42C52.23 97.71 52 97.94 51.71 97.95C51.42 97.96 51.18 97.73 51.18 97.44C51.15 94.34 51.56 91.72 52 88.87C52.44 86.03 52.92 82.95 53.03 78.99C53.04 78.54 53.06 78.1 53.07 77.66C53.19 73.82 53.3 70.38 52.56 68.16C51.53 65.08 51.75 62.43 52.89 60.16C54.16 57.63 56.56 55.59 59.62 53.96C63.27 52.01 67.18 48.02 70.05 43.7C72.79 39.58 74.57 35.19 74.26 32.03C73.82 27.6 70.81 24.15 66.47 21.79C61.55 19.1 54.94 17.83 48.42 18.12C41.91 18.41 36.64 20.22 32.88 22.98C30.01 25.08 28.02 27.73 27.02 30.67C26.03 33.61 26.04 36.84 27.15 40.1C28.5 44.05 31.48 48.05 36.3 51.64C37.82 52.78 39.56 53.67 41.24 54.52C44.58 56.22 47.67 57.79 48.61 61.07C49.35 63.66 48.95 65.97 48.5 68.57C48 71.44 47.44 74.66 48.39 78.96C49.14 82.4 49.65 85.65 49.98 88.51C50.43 92.39 50.55 95.54 50.51 97.38C50.51 97.66 50.27 97.9 49.98 97.89C49.69 97.89 49.46 97.66 49.47 97.37C49.5 95.58 49.39 92.49 48.94 88.64C48.61 85.82 48.11 82.59 47.36 79.19C46.38 74.7 46.96 71.36 47.47 68.4C47.55 67.92 47.64 67.45 47.71 66.98L47.69 66.98C47.9 65.06 46.98 63.54 45.5 62.49C44.54 61.81 43.35 61.32 42.07 61.07C40.8 60.81 39.44 60.77 38.17 60.99C35.9 61.38 33.91 62.58 33.11 64.72L33.11 64.72C33.04 64.96 32.95 65.23 32.83 65.51C31.39 69.01 31.77 72.98 33.13 76.76C34.83 81.48 38.08 85.89 41.27 88.69C42.98 90.19 44.37 90.64 45.43 90.98C47.57 91.67 48.61 92.01 48.67 97.4ZM40.79 31.94C40.65 32.04 40.45 32.01 40.35 31.87C40.25 31.73 40.28 31.53 40.43 31.43C41.67 30.53 43.17 29.81 44.84 29.34C46.45 28.88 48.2 28.64 50.04 28.67C51.84 28.71 53.54 29 55.09 29.49C56.7 30.01 58.13 30.75 59.32 31.66C59.46 31.77 59.48 31.96 59.37 32.1C59.27 32.24 59.07 32.27 58.93 32.16C57.8 31.3 56.43 30.59 54.89 30.09C53.4 29.61 51.76 29.33 50.02 29.3C48.25 29.27 46.55 29.5 45.01 29.94C43.41 30.39 41.98 31.08 40.79 31.94ZM36.09 31.02C35.97 31.14 35.77 31.15 35.64 31.04C35.52 30.92 35.51 30.72 35.63 30.59C37.22 28.89 39.39 27.5 41.94 26.56C44.39 25.66 47.19 25.17 50.15 25.22C53.1 25.28 55.87 25.87 58.26 26.87C60.75 27.9 62.84 29.38 64.32 31.14C64.43 31.27 64.41 31.47 64.28 31.58C64.15 31.69 63.95 31.68 63.84 31.54C62.42 29.86 60.42 28.45 58.02 27.45C55.7 26.48 53.01 25.9 50.13 25.85C47.25 25.8 44.53 26.27 42.15 27.15C39.7 28.06 37.61 29.39 36.09 31.02ZM47.96 63.56C47.93 62.84 47.82 62.11 47.61 61.37C46.79 58.52 43.89 57.04 40.75 55.45C39.04 54.58 37.26 53.68 35.66 52.48C30.68 48.76 27.58 44.58 26.16 40.44C24.97 36.96 24.97 33.5 26.04 30.35C27.1 27.2 29.22 24.37 32.27 22.14C36.19 19.27 41.66 17.38 48.39 17.08C55.09 16.78 61.9 18.09 66.98 20.87C71.6 23.39 74.82 27.11 75.3 31.92C75.63 35.33 73.78 39.97 70.92 44.27C67.96 48.73 63.9 52.85 60.1 54.88C57.23 56.41 54.99 58.3 53.83 60.62C53.28 61.7 52.97 62.88 52.95 64.17C53.65 62.92 54.82 61.92 56.23 61.22C57.36 60.66 58.63 60.29 59.93 60.12C61.22 59.96 62.54 60 63.76 60.27C65.2 60.6 66.5 61.23 67.44 62.22C67.67 61.69 68.19 61.19 69.25 60.18C69.8 59.66 70.51 58.98 71.42 58.08C75.98 53.52 80.37 48.22 83.07 42.41C85.36 37.45 86.42 32.11 85.29 26.54C83.58 18.6 76.49 13.31 67.41 10.6C61.84 8.93 55.52 8.23 49.22 8.48C42.93 8.73 36.68 9.93 31.22 12.05C21.88 15.68 14.91 22.02 14.28 30.96L14.28 30.96C13.72 43.64 21.3 51.2 29.4 59.27L29.7 59.56C30.15 60.01 30.64 60.38 31.11 60.72C31.96 61.34 32.71 61.89 33.06 62.69C34.23 61.19 36.04 60.3 38.01 59.96C39.41 59.72 40.89 59.76 42.29 60.04C43.7 60.33 45.03 60.87 46.12 61.64C46.87 62.17 47.5 62.82 47.96 63.56ZM81.5 17.41C79.17 13.8 76.08 10.9 72.51 8.68C66.35 4.85 58.75 3.04 51.12 3.04C41.58 3.05 31.78 5.54 24.68 10.93C20.86 13.84 17.81 17.61 16.02 22.29C19.1 17.32 24.44 13.57 30.86 11.07C36.42 8.91 42.8 7.69 49.2 7.44C55.6 7.19 62.04 7.9 67.72 9.6C73.27 11.26 78.1 13.85 81.5 17.41Z"
      />
      <path
        strokeWidth="0.8"
        d="M42.33 85.62C41.88 85.81 41.55 86.04 41.58 86.13C41.62 86.22 42.02 86.14 42.47 85.95C42.92 85.77 43.26 85.54 43.22 85.45C43.18 85.36 42.79 85.44 42.33 85.62ZM46.38 89.43C46.03 89.58 45.77 89.77 45.8 89.84C45.83 89.91 46.14 89.84 46.49 89.69C46.84 89.53 47.1 89.35 47.07 89.28C47.04 89.21 46.73 89.27 46.38 89.43ZM45.1 87.89C44.65 88.08 44.32 88.31 44.36 88.41C44.4 88.5 44.79 88.41 45.24 88.21C45.69 88.02 46.02 87.78 45.98 87.69C45.94 87.6 45.55 87.69 45.1 87.89ZM45.21 85.91C44.75 86.1 44.42 86.32 44.46 86.42C44.49 86.51 44.89 86.43 45.34 86.24C45.79 86.05 46.13 85.83 46.09 85.73C46.05 85.64 45.66 85.72 45.21 85.91ZM40.68 84.01C40.23 84.2 39.9 84.44 39.94 84.53C39.98 84.62 40.37 84.53 40.82 84.33C41.27 84.14 41.6 83.9 41.56 83.81C41.52 83.72 41.13 83.81 40.68 84.01ZM44.79 82.87C44.32 82.99 43.95 83.17 43.98 83.27C44 83.36 44.4 83.34 44.88 83.22C45.35 83.1 45.72 82.92 45.69 82.83C45.67 82.73 45.27 82.75 44.79 82.87ZM41.73 81.97C41.26 82.09 40.89 82.27 40.91 82.36C40.94 82.46 41.34 82.44 41.81 82.32C42.29 82.2 42.65 82.02 42.63 81.92C42.6 81.83 42.2 81.85 41.73 81.97ZM38.55 81.69C38.08 81.82 37.72 82 37.74 82.1C37.77 82.19 38.17 82.17 38.64 82.04C39.11 81.91 39.48 81.73 39.45 81.63C39.43 81.54 39.02 81.56 38.55 81.69ZM44.47 80.16C44 80.28 43.64 80.45 43.66 80.55C43.68 80.65 44.09 80.62 44.56 80.5C45.03 80.38 45.4 80.21 45.37 80.11C45.35 80.01 44.95 80.03 44.47 80.16ZM41.25 79.69C40.77 79.81 40.41 79.99 40.43 80.08C40.46 80.18 40.86 80.16 41.33 80.04C41.8 79.92 42.17 79.74 42.14 79.64C42.12 79.55 41.72 79.57 41.25 79.69ZM37.28 78.97C36.8 79.09 36.44 79.27 36.46 79.36C36.49 79.46 36.89 79.44 37.36 79.31C37.83 79.19 38.2 79.02 38.18 78.92C38.15 78.83 37.75 78.85 37.28 78.97ZM44.05 77.33C43.57 77.45 43.21 77.63 43.23 77.72C43.26 77.82 43.66 77.8 44.13 77.68C44.61 77.56 44.97 77.38 44.95 77.28C44.92 77.19 44.52 77.21 44.05 77.33ZM39.51 76.11C38.96 76.14 38.52 76.26 38.52 76.37C38.53 76.48 38.98 76.55 39.53 76.51C40.08 76.48 40.52 76.36 40.51 76.25C40.51 76.14 40.06 76.07 39.51 76.11ZM35.51 75.25C34.96 75.28 34.52 75.4 34.53 75.51C34.53 75.62 34.98 75.69 35.53 75.65C36.08 75.62 36.52 75.5 36.52 75.39C36.51 75.28 36.06 75.21 35.51 75.25ZM43.56 74.86C43.01 74.89 42.56 75.01 42.57 75.12C42.58 75.23 43.03 75.3 43.58 75.26C44.13 75.23 44.57 75.11 44.56 75C44.56 74.89 44.11 74.82 43.56 74.86ZM39.64 72.87C39.09 72.91 38.64 73.03 38.65 73.14C38.66 73.25 39.11 73.31 39.66 73.28C40.21 73.24 40.65 73.12 40.64 73.01C40.64 72.9 40.19 72.84 39.64 72.87ZM35.64 72.01C35.09 72.05 34.65 72.16 34.66 72.28C34.66 72.39 35.11 72.45 35.66 72.42C36.21 72.38 36.65 72.26 36.65 72.15C36.64 72.04 36.19 71.98 35.64 72.01ZM43.69 71.62C43.14 71.66 42.69 71.78 42.7 71.89C42.71 72 43.16 72.06 43.71 72.03C44.26 71.99 44.7 71.87 44.69 71.76C44.69 71.65 44.24 71.59 43.69 71.62ZM39.74 69.44C39.19 69.43 38.74 69.51 38.74 69.62C38.74 69.73 39.18 69.83 39.73 69.84C40.28 69.85 40.73 69.76 40.73 69.65C40.74 69.54 40.29 69.44 39.74 69.44ZM35.83 68.26C35.28 68.26 34.83 68.34 34.83 68.45C34.83 68.56 35.27 68.66 35.82 68.67C36.37 68.68 36.82 68.59 36.82 68.48C36.83 68.37 36.38 68.27 35.83 68.26ZM43.87 68.5C43.32 68.5 42.88 68.58 42.87 68.69C42.87 68.8 43.31 68.9 43.86 68.91C44.41 68.92 44.86 68.83 44.87 68.72C44.87 68.61 44.43 68.51 43.87 68.5ZM40.13 66.22C39.57 66.21 39.13 66.29 39.12 66.4C39.12 66.51 39.56 66.61 40.11 66.62C40.66 66.63 41.11 66.55 41.12 66.43C41.12 66.32 40.68 66.22 40.13 66.22ZM36.21 65.05C35.66 65.04 35.22 65.12 35.21 65.23C35.21 65.34 35.65 65.44 36.2 65.45C36.75 65.46 37.2 65.38 37.21 65.26C37.21 65.15 36.77 65.05 36.21 65.05ZM40.6 63.07C40.05 63.06 39.6 63.15 39.59 63.26C39.59 63.37 40.04 63.47 40.59 63.48C41.14 63.48 41.58 63.4 41.59 63.29C41.59 63.18 41.15 63.08 40.6 63.07ZM44.26 65.28C43.71 65.28 43.26 65.36 43.25 65.47C43.25 65.58 43.69 65.68 44.24 65.69C44.8 65.7 45.24 65.61 45.25 65.5C45.25 65.39 44.81 65.29 44.26 65.28ZM58.76 86.09C59.22 86.26 59.56 86.47 59.52 86.56C59.49 86.66 59.09 86.59 58.64 86.42C58.18 86.25 57.84 86.04 57.88 85.95C57.91 85.86 58.31 85.92 58.76 86.09ZM54.78 90.06C55.14 90.2 55.4 90.37 55.37 90.44C55.34 90.51 55.03 90.46 54.68 90.32C54.32 90.18 54.06 90 54.09 89.93C54.12 89.86 54.43 89.91 54.78 90.06ZM56.04 88.46C56.49 88.64 56.82 88.86 56.79 88.95C56.75 89.04 56.35 88.97 55.9 88.79C55.45 88.62 55.12 88.4 55.15 88.3C55.19 88.21 55.59 88.28 56.04 88.46ZM55.9 86.49C56.35 86.66 56.69 86.87 56.66 86.97C56.62 87.06 56.22 87 55.77 86.83C55.31 86.66 54.98 86.44 55.01 86.35C55.05 86.26 55.44 86.32 55.9 86.49ZM60.39 84.4C60.84 84.58 61.18 84.8 61.14 84.89C61.11 84.99 60.71 84.92 60.26 84.74C59.81 84.56 59.47 84.34 59.51 84.25C59.55 84.16 59.94 84.23 60.39 84.4ZM56.26 83.44C56.74 83.54 57.11 83.7 57.08 83.8C57.06 83.89 56.66 83.89 56.18 83.79C55.71 83.69 55.34 83.52 55.36 83.43C55.39 83.33 55.79 83.34 56.26 83.44ZM59.31 82.41C59.79 82.51 60.15 82.67 60.13 82.77C60.11 82.87 59.71 82.86 59.23 82.76C58.76 82.66 58.39 82.5 58.41 82.4C58.43 82.3 58.84 82.31 59.31 82.41ZM62.48 82.01C62.96 82.11 63.32 82.28 63.3 82.38C63.27 82.47 62.87 82.46 62.4 82.35C61.92 82.25 61.56 82.08 61.58 81.98C61.61 81.89 62.01 81.9 62.48 82.01ZM56.54 80.71C57.01 80.81 57.38 80.97 57.36 81.07C57.34 81.17 56.93 81.16 56.46 81.06C55.98 80.96 55.62 80.8 55.64 80.7C55.66 80.6 56.06 80.61 56.54 80.71ZM59.76 80.11C60.23 80.21 60.6 80.38 60.58 80.47C60.56 80.57 60.15 80.56 59.68 80.46C59.2 80.36 58.84 80.2 58.86 80.1C58.88 80.01 59.28 80.01 59.76 80.11ZM63.71 79.23C64.19 79.33 64.56 79.49 64.53 79.59C64.51 79.69 64.11 79.68 63.63 79.58C63.16 79.48 62.79 79.32 62.81 79.22C62.84 79.12 63.24 79.13 63.71 79.23ZM56.92 77.87C57.39 77.97 57.76 78.13 57.74 78.23C57.72 78.32 57.32 78.32 56.84 78.22C56.37 78.11 56 77.95 56.02 77.86C56.04 77.76 56.45 77.76 56.92 77.87ZM61.44 76.46C61.99 76.47 62.43 76.57 62.43 76.69C62.43 76.8 61.98 76.88 61.43 76.87C60.88 76.85 60.43 76.75 60.44 76.64C60.44 76.53 60.89 76.45 61.44 76.46ZM65.42 75.44C65.97 75.45 66.41 75.55 66.41 75.66C66.4 75.78 65.95 75.86 65.4 75.84C64.85 75.83 64.41 75.73 64.41 75.62C64.42 75.51 64.87 75.43 65.42 75.44ZM57.37 75.38C57.92 75.39 58.36 75.49 58.36 75.6C58.36 75.71 57.91 75.79 57.36 75.78C56.81 75.77 56.36 75.67 56.37 75.56C56.37 75.44 56.82 75.36 57.37 75.38ZM61.26 73.23C61.81 73.24 62.25 73.34 62.25 73.46C62.24 73.57 61.79 73.65 61.24 73.64C60.69 73.62 60.25 73.52 60.25 73.41C60.26 73.3 60.71 73.22 61.26 73.23ZM65.24 72.21C65.79 72.22 66.23 72.32 66.23 72.43C66.22 72.55 65.77 72.63 65.22 72.61C64.67 72.6 64.23 72.5 64.23 72.39C64.24 72.28 64.69 72.2 65.24 72.21ZM57.19 72.15C57.74 72.16 58.18 72.26 58.18 72.37C58.18 72.48 57.73 72.56 57.18 72.55C56.63 72.54 56.18 72.44 56.19 72.33C56.19 72.21 56.64 72.13 57.19 72.15ZM61.1 69.8C61.65 69.77 62.1 69.83 62.1 69.95C62.1 70.06 61.66 70.17 61.11 70.2C60.56 70.24 60.11 70.17 60.11 70.06C60.1 69.95 60.54 69.83 61.1 69.8ZM64.99 68.47C65.54 68.44 65.99 68.51 65.99 68.62C66 68.73 65.55 68.85 65 68.88C64.45 68.91 64 68.84 64 68.73C63.99 68.62 64.44 68.5 64.99 68.47ZM56.95 69.04C57.5 69.01 57.95 69.07 57.96 69.18C57.96 69.29 57.52 69.41 56.97 69.44C56.42 69.47 55.97 69.41 55.96 69.29C55.96 69.18 56.4 69.07 56.95 69.04ZM60.66 66.6C61.21 66.57 61.66 66.63 61.67 66.74C61.67 66.86 61.23 66.97 60.68 67C60.13 67.03 59.68 66.97 59.68 66.86C59.67 66.74 60.11 66.63 60.66 66.6ZM64.55 65.27C65.1 65.24 65.55 65.3 65.56 65.42C65.56 65.53 65.12 65.64 64.57 65.67C64.02 65.7 63.57 65.64 63.57 65.53C63.56 65.42 64 65.3 64.55 65.27ZM60.14 63.47C60.69 63.44 61.14 63.51 61.15 63.62C61.15 63.73 60.71 63.85 60.16 63.88C59.61 63.91 59.16 63.84 59.15 63.73C59.15 63.62 59.59 63.5 60.14 63.47ZM56.52 65.83C57.07 65.8 57.52 65.87 57.52 65.98C57.53 66.09 57.09 66.21 56.54 66.24C55.99 66.27 55.54 66.2 55.53 66.09C55.53 65.98 55.97 65.86 56.52 65.83Z"
      />
    </g>
  </svg>
);

export const ToolCobbAngle = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-cobb-angle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(6.5, 0.68)"
        fill="currentColor"
      >
        <path
          d="M8.5,10.1817844 C9.88071187,10.1817844 11,11.3010725 11,12.6817844 L11,13.6817844 C11,15.0624963 9.88071187,16.1817844 8.5,16.1817844 L2.5,16.1817844 C1.11928813,16.1817844 0,15.0624963 0,13.6817844 L0,12.6817844 C0,11.3010725 1.11928813,10.1817844 2.5,10.1817844 L8.5,10.1817844 Z M8.5,11.6817844 L2.5,11.6817844 C1.94771525,11.6817844 1.5,12.1294997 1.5,12.6817844 L1.5,13.6817844 C1.5,14.2340692 1.94771525,14.6817844 2.5,14.6817844 L8.5,14.6817844 C9.05228475,14.6817844 9.5,14.2340692 9.5,13.6817844 L9.5,12.6817844 C9.5,12.1294997 9.05228475,11.6817844 8.5,11.6817844 Z"
          id="Rectangle"
          fillRule="nonzero"
        ></path>
        <circle
          id="Oval"
          cx="6.5"
          cy="8.6976195"
          r="1"
        ></circle>
        <circle
          id="Oval"
          cx="6.5"
          cy="17.6976195"
          r="1"
        ></circle>
        <path
          d="M11.5,1.70018865 C12.8807119,1.70018865 14,2.81947678 14,4.20018865 L14,5.20018865 C14,6.58090053 12.8807119,7.70018865 11.5,7.70018865 L5.5,7.70018865 C4.11928813,7.70018865 3,6.58090053 3,5.20018865 L3,4.20018865 C3,2.81947678 4.11928813,1.70018865 5.5,1.70018865 L11.5,1.70018865 Z M11.5,3.20018865 L5.5,3.20018865 C4.94771525,3.20018865 4.5,3.6479039 4.5,4.20018865 L4.5,5.20018865 C4.5,5.7524734 4.94771525,6.20018865 5.5,6.20018865 L11.5,6.20018865 C12.0522847,6.20018865 12.5,5.7524734 12.5,5.20018865 L12.5,4.20018865 C12.5,3.6479039 12.0522847,3.20018865 11.5,3.20018865 Z"
          id="Rectangle"
          fillRule="nonzero"
          transform="translate(8.5, 4.7002) rotate(20) translate(-8.5, -4.7002)"
        ></path>
        <path
          d="M11.5,18.7001887 C12.8807119,18.7001887 14,19.8194768 14,21.2001887 L14,22.2001887 C14,23.5809005 12.8807119,24.7001887 11.5,24.7001887 L5.5,24.7001887 C4.11928813,24.7001887 3,23.5809005 3,22.2001887 L3,21.2001887 C3,19.8194768 4.11928813,18.7001887 5.5,18.7001887 L11.5,18.7001887 Z M11.5,20.2001887 L5.5,20.2001887 C4.94771525,20.2001887 4.5,20.6479039 4.5,21.2001887 L4.5,22.2001887 C4.5,22.7524734 4.94771525,23.2001887 5.5,23.2001887 L11.5,23.2001887 C12.0522847,23.2001887 12.5,22.7524734 12.5,22.2001887 L12.5,21.2001887 C12.5,20.6479039 12.0522847,20.2001887 11.5,20.2001887 Z"
          id="Rectangle"
          fillRule="nonzero"
          transform="translate(8.5, 21.7002) rotate(-20) translate(-8.5, -21.7002)"
        ></path>
      </g>
    </g>
  </svg>
);

export const ToolCreateThreshold = (props: IconProps) => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="create-threshold"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polyline
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="18.85656 16.2174437 21.3536565 13.7203472 23.850753 16.2174437"
      ></polyline>
      <polyline
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(21.353657, 21.471076) scale(1, -1) translate(-21.353657, -21.471076) "
        points="18.85656 22.7196245 21.3536565 20.222528 23.850753 22.7196245"
      ></polyline>
      <path
        d="M21.8903104,6.56040847 L11.830485,16.6215711 C11.7372012,16.7144344 11.6185826,16.7776976 11.4894966,16.8034316 L7.65571758,17.5696525 C7.43667607,17.6132586 7.21032569,17.5446155 7.05240058,17.3866904 C6.89447547,17.2287653 6.8258324,17.0024149 6.86943853,16.7833734 L7.63565944,12.9509316 C7.66176759,12.8216917 7.72550512,12.7030561 7.81885711,12.6099433 L17.8786825,2.54878063 C18.9836118,1.44420272 20.7746834,1.44420272 21.8796127,2.54878063 L21.8903104,2.56081551 C22.9947353,3.66528595 22.9947353,5.45593803 21.8903104,6.56040847 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="9.60946699"
        y1="12.6534866"
        x2="11.9466763"
        y2="14.9906958"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></line>
      <path
        d="M-5.52848657,13.180889 L-5.52848657,15.180889 C-5.52848657,16.7687077 -4.24130523,18.055889 -2.65348657,18.055889 L-1.21495403,18.055889 C-0.731704876,18.055889 -0.339954032,17.6641382 -0.339954032,17.180889 C-0.339954032,16.6976399 -0.731704876,16.305889 -1.21495403,16.305889 L-2.65348657,16.305889 C-3.27480692,16.305889 -3.77848657,15.8022094 -3.77848657,15.180889 L-3.77848657,13.180889 C-3.77848657,12.6976399 -4.17023742,12.305889 -4.65348657,12.305889 C-5.13673573,12.305889 -5.52848657,12.6976399 -5.52848657,13.180889 Z M3.03504597,18.055889 L9.53504597,18.055889 C10.0182951,18.055889 10.410046,17.6641382 10.410046,17.180889 C10.410046,16.6976399 10.0182951,16.305889 9.53504597,16.305889 L3.03504597,16.305889 C2.55179681,16.305889 2.16004597,16.6976399 2.16004597,17.180889 C2.16004597,17.6641382 2.55179681,18.055889 3.03504597,18.055889 Z M13.785046,18.055889 L15.180889,18.055889 C16.7687077,18.055889 18.055889,16.7687077 18.055889,15.180889 L18.055889,13.1381996 C18.055889,12.6549504 17.6641382,12.2631996 17.180889,12.2631996 C16.6976399,12.2631996 16.305889,12.6549504 16.305889,13.1381996 L16.305889,15.180889 C16.305889,15.8022094 15.8022094,16.305889 15.180889,16.305889 L13.785046,16.305889 C13.3017968,16.305889 12.910046,16.6976399 12.910046,17.180889 C12.910046,17.6641382 13.3017968,18.055889 13.785046,18.055889 Z M18.055889,8.88819957 L18.055889,6.65348657 C18.055889,6.17023742 17.6641382,5.77848657 17.180889,5.77848657 C16.6976399,5.77848657 16.305889,6.17023742 16.305889,6.65348657 L16.305889,8.88819957 C16.305889,9.37144872 16.6976399,9.76319957 17.180889,9.76319957 C17.6641382,9.76319957 18.055889,9.37144872 18.055889,8.88819957 Z"
        id="Path-4"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(6.263701, 11.917188) scale(1, -1) rotate(90.000000) translate(-6.263701, -11.917188) "
      ></path>
    </g>
  </svg>
);

export const ToolCrosshair = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-crosshair"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="cursor-target-2"
        transform="translate(3, 3)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <line
          x1="11"
          y1="-8.8817842e-16"
          x2="11"
          y2="6"
          id="Path"
        ></line>
        <line
          x1="0"
          y1="11"
          x2="6"
          y2="11"
          id="Path"
        ></line>
        <line
          x1="11"
          y1="22"
          x2="11"
          y2="16"
          id="Path"
        ></line>
        <line
          x1="22"
          y1="11"
          x2="16"
          y2="11"
          id="Path"
        ></line>
        <circle
          id="Oval"
          cx="11.001"
          cy="11.001"
          r="2"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolCrosshairChecked = (props: IconProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_tool_crosshair_checked)">
      <path
        d="M14 3V9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 14H9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 25V19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25 14H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.001 16.001C15.1056 16.001 16.001 15.1056 16.001 14.001C16.001 12.8964 15.1056 12.001 14.001 12.001C12.8964 12.001 12.001 12.8964 12.001 14.001C12.001 15.1056 12.8964 16.001 14.001 16.001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 17C24.7614 17 27 19.2386 27 22C27 24.7614 24.7614 27 22 27C19.2386 27 17 24.7614 17 22C17 19.2386 19.2386 17 22 17ZM24.7998 19.7998C24.5789 19.6344 24.2652 19.6796 24.0996 19.9004L21.4453 23.4385L19.8535 21.8467C19.6583 21.6514 19.3417 21.6514 19.1465 21.8467C18.9513 22.0419 18.9513 22.3585 19.1465 22.5537L21.1465 24.5537C21.2489 24.6561 21.3907 24.7094 21.5352 24.6992C21.6797 24.6889 21.8134 24.6159 21.9004 24.5L24.9004 20.5C25.0658 20.2791 25.0205 19.9654 24.7998 19.7998Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_tool_crosshair_checked">
        <rect
          width="28"
          height="28"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ToolDicomTagBrowser = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-dicom-tag-browser"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(4, 5.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <circle
          id="Oval"
          cx="1.73913043"
          cy="1.73913043"
          r="1.73913043"
        ></circle>
        <line
          x1="6.95652174"
          y1="1.73913043"
          x2="20"
          y2="1.73913043"
          id="Path"
        ></line>
        <circle
          id="Oval"
          cx="1.73913043"
          cy="8.69565217"
          r="1.73913043"
        ></circle>
        <line
          x1="6.95652174"
          y1="8.69565217"
          x2="20"
          y2="8.69565217"
          id="Path"
        ></line>
        <circle
          id="Oval"
          cx="1.73913043"
          cy="15.6521739"
          r="1.73913043"
        ></circle>
        <line
          x1="6.95652174"
          y1="15.6521739"
          x2="20"
          y2="15.6521739"
          id="Path"
        ></line>
      </g>
    </g>
  </svg>
);

export const ToolFlipHorizontal = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-flip-horizontal"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M10.6315789,7.31578947 L6,7.31578947 C4.8954305,7.31578947 4,8.21121997 4,9.31578947 L4,18.5789474 C4,19.6835169 4.8954305,20.5789474 6,20.5789474 L10.6315789,20.5789474 L10.6315789,20.5789474"
        id="Path-2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M25,7.31578947 L20.3684211,7.31578947 C19.2638516,7.31578947 18.3684211,8.21121997 18.3684211,9.31578947 L18.3684211,18.5789474 C18.3684211,19.6835169 19.2638516,20.5789474 20.3684211,20.5789474 L25,20.5789474 L25,20.5789474"
        id="Path-2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="1,3.1"
        transform="translate(21.6842, 13.9474) scale(-1, 1) translate(-21.6842, -13.9474)"
      ></path>
      <line
        x1="14.5"
        y1="4.55263158"
        x2="14.5"
        y2="23.3421053"
        id="Line-3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></line>
    </g>
  </svg>
);

export const ToolFreehandPolygon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      id="icon-freehand-sculpt"
      fill="none"
      strokeWidth="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line
        id="svg_1"
        y2="2.559367"
        x2="10.184807"
        y1="4.467781"
        x1="8.81711"
      />
      <line
        id="svg_4"
        y2="1.493836"
        x2="11.727442"
        y1="2.766112"
        x1="10.089386"
      />
      <line
        id="svg_7"
        y2="1.080346"
        x2="13.047428"
        y1="1.748291"
        x1="11.345759"
      />
      <line
        id="svg_8"
        y2="1.000829"
        x2="14.351511"
        y1="1.112153"
        x1="12.77707"
      />
      <line
        id="svg_9"
        y2="1.350705"
        x2="15.242104"
        y1="0.905408"
        x1="13.969828"
      />
      <line
        id="svg_10"
        y2="2.098167"
        x2="15.862339"
        y1="1.14396"
        x1="14.955842"
      />
      <line
        id="svg_11"
        y2="3.195505"
        x2="16.41896"
        y1="1.939133"
        x1="15.766918"
      />
      <line
        id="svg_12"
        y2="4.292843"
        x2="16.530284"
        y1="2.925147"
        x1="16.387153"
      />
      <line
        id="svg_16"
        y2="5.644637"
        x2="16.196311"
        y1="3.831643"
        x1="16.593898"
      />
      <line
        id="svg_18"
        y2="7.266789"
        x2="15.623787"
        y1="5.19934"
        x1="16.275829"
      />
      <line
        id="svg_19"
        y2="10.813258"
        x2="14.526449"
        y1="6.726071"
        x1="15.766918"
      />
      <line
        id="svg_20"
        y2="5.056209"
        x2="8.085552"
        y1="4.181519"
        x1="8.976145"
      />
      <line
        id="svg_23"
        y2="5.326568"
        x2="7.481221"
        y1="4.78585"
        x1="8.403621"
      />
      <line
        id="svg_24"
        y2="5.565119"
        x2="6.749662"
        y1="5.294761"
        x1="7.624352"
      />
      <line
        id="svg_25"
        y2="5.994512"
        x2="5.429675"
        y1="5.533312"
        x1="6.956407"
      />
      <line
        id="svg_27"
        y2="6.551133"
        x2="4.284627"
        y1="5.962706"
        x1="5.572807"
      />
      <line
        id="svg_28"
        y2="7.584858"
        x2="3.044158"
        y1="6.392099"
        x1="4.427758"
      />
      <line
        id="svg_29"
        y2="8.84123"
        x2="2.185372"
        y1="7.489437"
        x1="3.219096"
      />
      <line
        id="svg_31"
        y2="10.606513"
        x2="1.644654"
        y1="8.602678"
        x1="2.280792"
      />
      <line
        id="svg_32"
        y2="13.214679"
        x2="1.48562"
        y1="10.352058"
        x1="1.724171"
      />
      <line
        id="svg_33"
        y2="14.375631"
        x2="1.676461"
        y1="12.992031"
        x1="1.453813"
      />
      <line
        id="svg_34"
        y2="15.298031"
        x2="2.264889"
        y1="14.152983"
        x1="1.517427"
      />
      <line
        id="svg_35"
        y2="16.172721"
        x2="3.521261"
        y1="14.948155"
        x1="1.915013"
      />
      <line
        id="svg_36"
        y2="16.824762"
        x2="5.207027"
        y1="15.997783"
        x1="3.28271"
      />
      <line
        id="svg_38"
        y2="17.063314"
        x2="7.035924"
        y1="16.745245"
        x1="4.968475"
      />
      <line
        id="svg_39"
        y2="16.888376"
        x2="9.278311"
        y1="17.047411"
        x1="6.733758"
      />
      <line
        id="svg_40"
        y2="16.284045"
        x2="10.661911"
        y1="16.983797"
        x1="8.992048"
      />
      <line
        id="svg_41"
        y2="15.313934"
        x2="11.647925"
        y1="16.395369"
        x1="10.455166"
      />
      <line
        id="svg_44"
        y2="13.898527"
        x2="12.82478"
        y1="15.425259"
        x1="11.504794"
      />
      <line
        id="svg_45"
        y2="12.037824"
        x2="14.144766"
        y1="14.312017"
        x1="12.522614"
      />
      <line
        id="svg_47"
        y2="10.59061"
        x2="14.605966"
        y1="12.228665"
        x1="13.953925"
      />
      <ellipse
        ry="1"
        rx="1"
        id="svg_48"
        cy="3.982726"
        cx="13.460918"
      />
    </g>
  </svg>
);

export const ToolFreehandRoi = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-freehand-roi"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group-2"
        transform="translate(3, 2)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <path
          d="M0,0 C8,3 5,8.5 2,15.5 C-1,22.5 3.5,23 5,23 C6.08963707,23.0518834 7.15942037,22.6952889 8,22"
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M21.38,12.619 L13.75,20.25 L10,21 L10.75,17.25 L18.38,9.619 C19.2062949,8.79296781 20.5457051,8.79296781 21.372,9.619 L21.38,9.628 C21.7771113,10.0243763 22.000268,10.5624193 22.000268,11.1235 C22.000268,11.6845807 21.7771113,12.2226237 21.38,12.619 L21.38,12.619 Z"
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M10.654274,17.2961006 C11.6738332,18.1907082 12.6933924,19.0853157 13.7129517,19.9799232"
          id="Path-4"
        ></path>
      </g>
    </g>
  </svg>
);

export const ToolFreehand = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="miter"
    >
      <ellipse
        ry="1"
        rx="1"
        id="svg_3"
        cy="4.240343"
        cx="14.306499"
      />
      <line
        id="svg_4"
        y2="3.58462"
        x2="12.242186"
        y1="3.997482"
        x1="13.432202"
      />
      <line
        id="svg_5"
        y2="3.268901"
        x2="10.857882"
        y1="3.608906"
        x1="12.387902"
      />
      <line
        id="svg_6"
        y2="3.147471"
        x2="9.740724"
        y1="3.293187"
        x1="10.955026"
      />
      <line
        id="svg_7"
        y2="3.147471"
        x2="8.089274"
        y1="3.196043"
        x1="9.983585"
      />
      <line
        id="svg_8"
        y2="3.268901"
        x2="6.874972"
        y1="3.123185"
        x1="8.307848"
      />
      <line
        id="svg_9"
        y2="3.657478"
        x2="5.587812"
        y1="3.220329"
        x1="7.020688"
      />
      <line
        id="svg_10"
        y2="4.046054"
        x2="4.737801"
        y1="3.560334"
        x1="5.854959"
      />
      <line
        id="svg_11"
        y2="4.337487"
        x2="4.300652"
        y1="3.997482"
        x1="4.834945"
      />
      <line
        id="svg_12"
        y2="4.726063"
        x2="3.88779"
        y1="4.191771"
        x1="4.470655"
      />
      <line
        id="svg_15"
        y2="5.3575"
        x2="3.377783"
        y1="4.604633"
        x1="3.960648"
      />
      <line
        id="svg_16"
        y2="6.183226"
        x2="2.916348"
        y1="5.138926"
        x1="3.547785"
      />
      <line
        id="svg_17"
        y2="6.960379"
        x2="2.770632"
        y1="5.867507"
        x1="3.037779"
      />
      <line
        id="svg_18"
        y2="7.713246"
        x2="2.673488"
        y1="6.741804"
        x1="2.819204"
      />
      <line
        id="svg_19"
        y2="8.684687"
        x2="2.697774"
        y1="7.616102"
        x1="2.673488"
      />
      <line
        id="svg_20"
        y2="9.753273"
        x2="2.892062"
        y1="8.611829"
        x1="2.697774"
      />
      <line
        id="svg_21"
        y2="10.724714"
        x2="3.134923"
        y1="9.534698"
        x1="2.84349"
      />
      <line
        id="svg_23"
        y2="11.647583"
        x2="3.596357"
        y1="10.578998"
        x1="3.086351"
      />
      <line
        id="svg_25"
        y2="12.521881"
        x2="4.276366"
        y1="11.501867"
        x1="3.499213"
      />
      <line
        id="svg_26"
        y2="13.930471"
        x2="5.830673"
        y1="12.376165"
        x1="4.13065"
      />
      <line
        id="svg_28"
        y2="14.707624"
        x2="7.263549"
        y1="13.881899"
        x1="5.733528"
      />
      <line
        id="svg_29"
        y2="15.339061"
        x2="8.963571"
        y1="14.61048"
        x1="7.06926"
      />
      <line
        id="svg_30"
        y2="15.581921"
        x2="10.882168"
        y1="15.314775"
        x1="8.817855"
      />
      <line
        id="svg_31"
        y2="15.460491"
        x2="12.023612"
        y1="15.581921"
        x1="10.785024"
      />
      <line
        id="svg_33"
        y2="15.120487"
        x2="13.092197"
        y1="15.484777"
        x1="11.877895"
      />
      <line
        id="svg_34"
        y2="14.586194"
        x2="13.86935"
        y1="15.217631"
        x1="12.897909"
      />
      <line
        id="svg_35"
        y2="13.833327"
        x2="14.597931"
        y1="14.756196"
        x1="13.699348"
      />
      <line
        id="svg_37"
        y2="12.716169"
        x2="15.180796"
        y1="13.881899"
        x1="14.549359"
      />
      <line
        id="svg_39"
        y2="11.429009"
        x2="15.520801"
        y1="12.813313"
        x1="15.15651"
      />
      <ellipse
        ry="1"
        rx="1"
        id="svg_40"
        cy="10.967574"
        cx="15.520801"
      />
    </g>
  </svg>
);

export const ToolFusionColor = (props: IconProps) => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M18,2 C19.1045695,2 20,2.8954305 20,4 L20.000443,11.5700239 C18.8210504,10.0206853 17.6279451,8.77097591 17.1182222,8.25530435 C16.9570959,8.09231818 16.733654,8.00006956 16.5,8.00006956 C16.266346,8.00006956 16.0429041,8.09231818 15.8817778,8.25530435 C14.719,9.43165217 10,14.4278261 10,18.0869565 C10,18.7674866 10.1126915,19.4091677 10.3210825,20.0009348 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,4 C2,2.8954305 2.8954305,2 4,2 L18,2 Z"
        id="Combined-Shape"
        stroke="currentColor"
        strokeWidth="1.75"
      ></path>
      <g
        id="color-drop-pick"
        transform="translate(9.591386, 8.000070)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M7.52683573,0.255234787 C7.36570938,0.0922486197 7.14226748,0 6.90861351,0 C6.67495954,0 6.45151764,0.0922486197 6.29039129,0.255234787 C5.12761351,1.43158261 0.408613509,6.42775653 0.408613509,10.086887 C0.408613509,13.5449739 3.31844684,15.9999304 6.90861351,15.9999304 C10.4987802,15.9999304 13.4086135,13.5449739 13.4086135,10.086887 C13.4086135,6.42775653 8.68961351,1.43158261 7.52683573,0.255234787 Z"
          id="Path"
          strokeWidth="1.75"
        ></path>
        <g
          id="Group"
          transform="translate(7.015298, 8.975291) rotate(40.000000) translate(-7.015298, -8.975291) translate(3.731654, 1.974720)"
        >
          <line
            x1="0.5"
            y1="12.5"
            x2="0.5"
            y2="1.56125113e-15"
            id="Path"
          ></line>
          <line
            x1="3.420153"
            y1="1.25018584"
            x2="3.420153"
            y2="14.0011428"
            id="Path"
          ></line>
          <line
            x1="6.06728889"
            y1="1.86765717"
            x2="6.06728889"
            y2="12.7034832"
            id="Path"
          ></line>
        </g>
      </g>
    </g>
  </svg>
);

export const ToolInvert = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-invert"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="4"
        y="5"
        width="20"
        height="18"
        rx="2"
      ></rect>
      <path
        d="M14,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,7 C4,5.8954305 4.8954305,5 6,5 L14,5 L14,8 C10.6862915,8 8,10.6862915 8,14 C8,17.3137085 10.6862915,20 14,20 L14,23 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
      <path
        d="M14,8 C17.3137085,8 20,10.6862915 20,14 C20,17.3137085 17.3137085,20 14,20 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);

export const ToolLayoutDefault = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-layout"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(0.5, 4)"
        strokeLinecap="round"
      >
        <g
          id="Group-3"
          transform="translate(0, 0)"
          stroke="currentColor"
          strokeWidth="1.25"
        >
          <path
            d="M5.45696821e-12,9.49450549 L5.45696821e-12,17.3947362 C5.45710348e-12,18.4993057 0.8954305,19.3947362 2,19.3947362 L13.2443085,19.3947362 L13.2443085,19.3947362"
            id="Path-3"
          ></path>
          <path
            d="M9.49450549,0 L9.49450549,4.91369247 L9.49450549,6 C9.49450549,7.1045695 10.389936,8 11.4945055,8 L19.195248,8 L19.195248,8"
            id="Path-3"
            transform="translate(14.3449, 4) rotate(180) translate(-14.3449, -4)"
          ></path>
          <path
            d="M0.0997440877,-0.0997440877 L0.0997440877,7.80048659 C0.0997440877,8.90505609 0.995174588,9.80048659 2.09974409,9.80048659 L9.80048659,9.80048659 L9.80048659,9.80048659"
            id="Path-3"
            transform="translate(4.9501, 4.8504) rotate(90) translate(-4.9501, -4.8504)"
          ></path>
        </g>
        <g
          id="Group-10"
          opacity="0.550000012"
          transform="translate(2, 2)"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <line
            x1="7.5"
            y1="14.5"
            x2="7.5"
            y2="0.5"
            id="Line-2"
          ></line>
          <line
            x1="7"
            y1="14"
            x2="7"
            y2="1"
            id="Line-2"
            transform="translate(7, 7.5) rotate(90) translate(-7, -7.5)"
          ></line>
        </g>
        <g
          id="gear"
          transform="translate(21.0876, 17.2796) rotate(-20) translate(-21.0876, -17.2796)translate(15.9634, 11.5127)"
          stroke="#348CFD"
          strokeLinejoin="round"
          strokeWidth="1.25"
        >
          <circle
            id="Oval"
            cx="5.12378058"
            cy="5.76719178"
            r="1.28158482"
          ></circle>
          <path
            d="M6.21361819,0.80762797 L6.59086967,2.04907966 C6.72061095,2.47639719 7.15892721,2.73042581 7.59419808,2.63056421 L8.85259487,2.33893009 C9.34216301,2.22858155 9.84650092,2.45011894 10.0964357,2.88530436 C10.3463705,3.32048979 10.2835655,3.86774756 9.94154064,4.23499782 L9.06128718,5.18481538 C8.75980718,5.51248709 8.75980718,6.0165454 9.06128718,6.3442171 L9.94154064,7.29403466 C10.2835655,7.66128493 10.3463705,8.2085427 10.0964357,8.64372812 C9.84650092,9.07891354 9.34216301,9.30045094 8.85259487,9.1901024 L7.59419808,8.89846827 C7.15663131,8.79632613 6.71524652,9.05279063 6.58730228,9.48352022 L6.2100508,10.7249719 C6.0649735,11.2053044 5.62242271,11.5339347 5.12065911,11.5339347 C4.61889551,11.5339347 4.17634472,11.2053044 4.03126742,10.7249719 L3.65669148,9.48352022 C3.52807698,9.05567912 3.08963152,8.80095947 2.65425492,8.90114382 L1.39585813,9.19277794 C0.90628999,9.30312648 0.401952083,9.08158909 0.152017275,8.64640366 C-0.0979175321,8.21121824 -0.035112502,7.66396047 0.306912358,7.29671021 L1.18716582,6.34689264 C1.48864582,6.01922094 1.48864582,5.51516263 1.18716582,5.18749093 L0.306912358,4.23767336 C-0.035112502,3.8704231 -0.0979175321,3.32316533 0.152017275,2.88797991 C0.401952083,2.45279448 0.90628999,2.23125709 1.39585813,2.34160563 L2.65425492,2.63323975 C3.08937078,2.73350334 3.52770594,2.47923776 3.65669148,2.0517552 L4.03483481,0.810303513 C4.17932126,0.32979188 4.62146882,0.000617032116 5.12323309,0 C5.62499736,-0.000615299293 6.06795204,0.327472644 6.21361819,0.80762797 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ToolMagneticRoi = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-livewire"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <line
        x1="12.5"
        y1="6.5"
        x2="8.5"
        y2="9.5"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></line>
      <line
        x1="6.5"
        y1="12.5"
        x2="5.5"
        y2="19.5"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></line>
      <g
        id="Group"
        transform="translate(16.998, 17.5912) rotate(45) translate(-16.998, -17.5912)translate(12.496, 13.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <line
          x1="0.00327299164"
          y1="2.45474373"
          x2="3.27626463"
          y2="2.45474373"
          id="Path"
        ></line>
        <line
          x1="5.73100836"
          y1="2.45474373"
          x2="9.004"
          y2="2.45474373"
          id="Path"
        ></line>
        <path
          d="M5.72773537,4.09123955 C5.72773537,4.76909831 5.17822227,5.31861141 4.5003635,5.31861141 C3.82250474,5.31861141 3.27299164,4.76909831 3.27299164,4.09123955 L3.27299164,0.81824791 C3.25976214,0.371936739 2.9010549,0.0132295012 2.45474373,-5.11613498e-14 L0.81824791,-5.11613498e-14 C0.371936739,0.0132295012 0.0132295012,0.371936739 0,0.81824791 L0,4.09123955 C0,6.80209487 2.01452635,8.1824791 4.5003635,8.1824791 C6.98620065,8.1824791 9.00072701,6.80209487 9.00072701,4.09123955 L9.00072701,0.81824791 C8.98749751,0.371936739 8.62879027,0.0132295012 8.1824791,-5.11613498e-14 L6.54598328,-5.11613498e-14 C6.09967211,0.0132295012 5.74096487,0.371936739 5.72773537,0.81824791 L5.72773537,4.09123955 Z"
          id="Path"
        ></path>
      </g>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="14.5"
        cy="5.5"
        r="1.5"
      ></circle>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="5.5"
        cy="21.5"
        r="1.5"
      ></circle>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="7"
        cy="10.5"
        r="1.5"
      ></circle>
    </g>
  </svg>
);

export const ToolMagnify = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom-in"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="12.75"
        cy="12.7491667"
        r="8.33333333"
      ></circle>
      <line
        x1="23.5833333"
        y1="23.5825"
        x2="18.6425"
        y2="18.6416667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="8.58333333"
        y1="12.7491667"
        x2="16.9166667"
        y2="12.7491667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="12.75"
        y1="8.5825"
        x2="12.75"
        y2="16.9158333"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolMeasureEllipse = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-measure-elipse"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(1.6119, 2.6735)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="19.8333333"
          y1="14.625"
          x2="19.8333333"
          y2="22.9583333"
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <line
          x1="24"
          y1="18.7916667"
          x2="15.6666667"
          y2="18.7916667"
          id="Path"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <ellipse
          id="Oval"
          transform="translate(10.5, 7) rotate(89) translate(-10.5, -7)"
          cx="10.5"
          cy="7"
          rx="6.5"
          ry="10"
        ></ellipse>
      </g>
    </g>
  </svg>
);

export const ToolEllipticalAngleRoi = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-elliptical-angle-roi"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="ellipse-angle"
        transform="translate(2.5, 3.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <ellipse
          id="roi"
          cx="11.5"
          cy="10.5"
          rx="9.75"
          ry="7"
          strokeWidth="1.5"
        ></ellipse>
        <line
          id="arm-upper"
          x1="11.5"
          y1="10.5"
          x2="19.25"
          y2="6.25"
          strokeWidth="1.5"
        ></line>
        <line
          id="arm-lower"
          x1="11.5"
          y1="10.5"
          x2="18.3"
          y2="15.8"
          strokeWidth="1.5"
        ></line>
        <path
          id="angle"
          d="M14.65,8.75 C15.55,9.9 15.55,12 14.55,13.3"
          strokeWidth="1.25"
        ></path>
        <circle
          id="center"
          cx="11.5"
          cy="10.5"
          r="1.25"
          fill="currentColor"
          strokeWidth="0"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolMoreMenu = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 6"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M0 0L29 0 29 29 0 29z"
        transform="translate(-4.5 -11.5)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M7.25 12.083c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417zm14.5 0c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417zm-7.25 0c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417z"
        transform="translate(-4.5 -11.5)"
      />
    </g>
  </svg>
);

export const ToolMove = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-move"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <line
        x1="13.8823529"
        y1="22.5294118"
        x2="13.8823529"
        y2="4"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="22.5294118"
        y1="13.8823529"
        x2="5.23529412"
        y2="13.8823529"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="11.4117647 6.46832349 13.8800882 4 16.3642969 6.48420875"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(13.888, 22.5362) rotate(-180) translate(-13.888, -22.5362)"
        points="11.4117647 23.7624411 13.8800882 21.2941176 16.3642969 23.7783264"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(5.2421, 13.888) rotate(-90) translate(-5.2421, -13.888)"
        points="2.76583826 15.1142499 5.23416174 12.6459264 7.71837049 15.1301352"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(22.5362, 13.888) rotate(-270) translate(-22.5362, -13.888)"
        points="20.0599559 15.1142499 22.5282794 12.6459264 25.0124881 15.1301352"
      ></polyline>
    </g>
  </svg>
);

export const ToolPanHand = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-pan-hand"
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.65"
    >
      <path d="M10.25 13.05V7.1a1.65 1.65 0 0 1 3.3 0v5.05" />
      <path d="M13.55 12.15V5.95a1.65 1.65 0 0 1 3.3 0v6.45" />
      <path d="M16.85 12.35V7.2a1.58 1.58 0 0 1 3.15 0v7.2" />
      <path d="M20 14.4v-3.05a1.48 1.48 0 0 1 2.95 0v4.45c0 5.2-3.05 8.25-7.75 8.25h-1.35c-3.15 0-4.95-1.55-6.65-4.1l-2.05-3.1a1.62 1.62 0 0 1 .45-2.25 1.75 1.75 0 0 1 2.35.37l1.85 2.15" />
      <path d="M10.25 13.05v4.05" />
    </g>
  </svg>
);

export const ToolPolygon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    {...props}
  >
    <polygon
      points="24 1, 46 18, 40 49, 9 49, 1 18"
      stroke="currentColor"
      strokeWidth="3"
      fill="none"
    />
  </svg>
);

export const ToolQuickMagnify = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom-in"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="12.75"
        cy="12.7491667"
        r="8.33333333"
      ></circle>
      <line
        x1="23.5833333"
        y1="23.5825"
        x2="18.6425"
        y2="18.6416667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="8.58333333"
        y1="12.7491667"
        x2="16.9166667"
        y2="12.7491667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="12.75"
        y1="8.5825"
        x2="12.75"
        y2="16.9158333"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolRectangle = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-rectangle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group-8"
        transform="translate(15.8182, 15.5)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.65"
      >
        <line
          x1="3.78787879"
          y1="1.69561335e-14"
          x2="3.78787879"
          y2="7.57575758"
          id="Path"
        ></line>
        <line
          x1="7.57575758"
          y1="3.78787879"
          x2="-1.37263938e-13"
          y2="3.78787879"
          id="Path"
        ></line>
      </g>
      <path
        d="M12.030303,19.2878788 L6,19.2878788 C4.8954305,19.2878788 4,18.3924483 4,17.2878788 L4,7.5 C4,6.3954305 4.8954305,5.5 6,5.5 L19.8924006,5.5 C20.9969701,5.5 21.8924006,6.3954305 21.8924006,7.5 L21.8924006,12.0059038 L21.8924006,12.0059038"
        id="Path-5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export const ToolReferenceLines = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-reference-lines"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M5.75,14.75 L7.75,14.75 C8.16421356,14.75 8.5,14.4142136 8.5,14 C8.5,13.5857864 8.16421356,13.25 7.75,13.25 L5.75,13.25 C5.33578644,13.25 5,13.5857864 5,14 C5,14.4142136 5.33578644,14.75 5.75,14.75 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M10.75,14.75 L12.75,14.75 C13.1642136,14.75 13.5,14.4142136 13.5,14 C13.5,13.5857864 13.1642136,13.25 12.75,13.25 L10.75,13.25 C10.3357864,13.25 10,13.5857864 10,14 C10,14.4142136 10.3357864,14.75 10.75,14.75 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M15.75,14.75 L17.75,14.75 C18.1642136,14.75 18.5,14.4142136 18.5,14 C18.5,13.5857864 18.1642136,13.25 17.75,13.25 L15.75,13.25 C15.3357864,13.25 15,13.5857864 15,14 C15,14.4142136 15.3357864,14.75 15.75,14.75 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M20.75,14.75 L22.75,14.75 C23.1642136,14.75 23.5,14.4142136 23.5,14 C23.5,13.5857864 23.1642136,13.25 22.75,13.25 L20.75,13.25 C20.3357864,13.25 20,13.5857864 20,14 C20,14.4142136 20.3357864,14.75 20.75,14.75 Z"
        id="Path"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
      <path
        d="M6.25,10 L6.25,7 C6.25,6.44771525 6.69771525,6 7.25,6 L12.9765472,6 L12.9765472,6 L21.25,6 C21.8022847,6 22.25,6.44771525 22.25,7 L22.25,10 L22.25,10"
        id="Path-7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M6.25,22.426395 L6.25,19.426395 C6.25,18.8741103 6.69771525,18.426395 7.25,18.426395 L21.25,18.426395 C21.8022847,18.426395 22.25,18.8741103 22.25,19.426395 L22.25,22.426395 L22.25,22.426395"
        id="Path-7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        transform="translate(14.25, 20.4264) scale(1, -1) translate(-14.25, -20.4264)"
      ></path>
    </g>
  </svg>
);

export const ToolProbe = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(4 4)"
    >
      <path d="M10 0L10 3.333M10 16.667L10 20M0 10L3.333 10M16.667 10L20 10" />
      <circle
        cx="10"
        cy="10"
        r="6.667"
      />
      <path d="M10 9.583c.23 0 .417.187.417.417 0 .23-.187.417-.417.417-.23 0-.417-.187-.417-.417 0-.23.187-.417.417-.417" />
    </g>
  </svg>
);

export const ToolReset = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-reset"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <polyline
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="15.7879373 10.9230769 22.7110142 10.9230769 22.7110142 4"
      ></polyline>
      <path
        d="M22.1848604,10.9230769 C20.7833124,6.95640473 16.8769835,4.43920288 12.6856477,4.80187309 C8.49431195,5.16454329 5.07842549,8.3153258 4.37906817,12.4637863 C3.67971085,16.6122468 5.8738281,20.708777 9.71461129,22.4255209 C13.5553945,24.1422648 18.0710813,23.0448664 20.6956296,19.7569231"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolRotateRight = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-rotate-right"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <rect
        id="Rectangle"
        fill="currentColor"
        x="9.55555556"
        y="13"
        width="14.4444444"
        height="11.1111111"
        rx="2"
      ></rect>
      <g
        id="Group-11"
        transform="translate(4, 3)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          d="M8.88888889,3.33333333 L4.44444444,3.33333333 C1.98984556,3.33333333 0,5.32317889 0,7.77777778 L0,12.2222222"
          id="Path"
        ></path>
        <polyline
          id="Path"
          points="5.55555556 0 8.88888889 3.33333333 5.55555556 6.66666667"
        ></polyline>
      </g>
    </g>
  </svg>
);

export const ToolInteractiveRotate = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-interactive-rotate"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Arrows"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          d="M8.2,7.8 C9.8,6.2 11.9,5.3 14.2,5.3 C17.6,5.3 20.6,7.3 22,10.2"
          id="TopArc"
        ></path>
        <polyline
          id="TopArrow"
          points="21.6 6.8 22.5 10.8 18.6 9.8"
        ></polyline>
        <path
          d="M19.8,21.1 C18.2,22.6 16.1,23.4 13.8,23.4 C10.4,23.4 7.4,21.4 6,18.5"
          id="BottomArc"
        ></path>
        <polyline
          id="BottomArrow"
          points="6.4 21.9 5.5 17.9 9.4 18.9"
        ></polyline>
      </g>
    </g>
  </svg>
);

export const ToolSegBrush = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-brush"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M3.24640621,21.8286833 C3.09173375,21.7551472 2.99513748,21.5971513 3.00018895,21.4259625 C3.00524042,21.2547737 3.11098486,21.1027485 3.26972426,21.0384606 C5.3260304,20.2059201 4.66362518,17.8620247 5.27421252,16.6088957 C6.02197747,15.1026514 7.84114758,14.4766383 9.35746132,15.2037675 C13.9485253,17.4422999 8.48346644,24.3211232 3.24640621,21.8286833 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M21.5968442,2.302022 C21.1256527,1.8826075 20.4094461,1.90228142 19.9619901,2.34693083 L9.69255027,12.5887345 C11.0536437,13.0051578 12.1843437,13.9616637 12.8206229,15.2349008 L21.7410706,3.93687606 C22.1347378,3.44008272 22.0714081,2.72222021 21.5968442,2.302022 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolSegEraser = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-eraser"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M8.47826087,18.0030772 C7.48731947,17.9495317 6.54439458,17.5591084 5.80565217,16.8964685 L4.1066087,15.1958598 C3.49763625,14.5834856 3.49763625,13.5942339 4.1066087,12.9818598 L13.6317391,3.45672934 C14.2441133,2.84775689 15.233365,2.84775689 15.8457391,3.45672934 L19.8926087,7.5035989 C20.5015811,8.11597307 20.5015811,9.10522473 19.8926087,9.7175989 L12.7153043,16.8949033 C11.9769855,17.5579476 11.0343414,17.9489213 10.0434783,18.0030772 L8.47826087,18.0030772 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="10.0434783"
        y1="7.04499021"
        x2="16.3043478"
        y2="13.3058598"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="3"
        y1="20.5667293"
        x2="21"
        y2="20.5667293"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolSegShape = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-shape"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="16"
        cy="15"
        r="6"
      ></circle>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="3"
        y="3"
        width="13"
        height="13"
        rx="2"
      ></rect>
    </g>
  </svg>
);

export const ToolSegThreshold = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-threshold"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <g
        id="Group"
        transform="translate(2.4184, 14.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16.5816327"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="12.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="14.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
      <g
        id="Group"
        transform="translate(11.7092, 7.4592) scale(-1, 1) translate(-11.7092, -7.4592)translate(1.9184, 5.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="11"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="13.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolSplineRoi = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-spline-roi"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group-3"
        transform="translate(5, 5)"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          d="M5,4 C6.80276265,2.42407491 9.10583462,1.538278 11.5,1.5 L15.5,1.5"
          id="Path"
        ></path>
        <path
          d="M1.5,15.5 L1.5,11.5 C1.50313857,9.33936854 2.19845937,7.23658385 3.484,5.5"
          id="Path"
        ></path>
        <circle
          id="Oval"
          strokeLinecap="round"
          cx="4"
          cy="4.5"
          r="1.5"
        ></circle>
        <circle
          id="Oval"
          strokeLinecap="round"
          cx="17.5"
          cy="1.5"
          r="1.5"
        ></circle>
        <circle
          id="Oval"
          strokeLinecap="round"
          cx="1.5"
          cy="17.5"
          r="1.5"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolStackImageSync = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-stack-image-sync"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M16.4346891,14.4875228 L16.5216447,14.5744783 C17.2833202,15.336115 18.5181991,15.336115 19.2798746,14.5744783 L23.1459183,10.7049564 C24.2824086,9.55997894 24.2824086,7.71258895 23.1459183,6.56761146 L21.4311549,4.85371762 C20.2872588,3.71542746 18.4385755,3.71542746 17.2946795,4.85371762 L13.4277663,8.71976127 C12.6661296,9.48143685 12.6661296,10.7163157 13.4277663,11.4779913 L13.5147218,11.5649468"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.5651784,13.5118815 L11.4782229,13.424926 C10.7165473,12.6632893 9.48166848,12.6632893 8.7199929,13.424926 L4.85307969,17.2944478 C3.7156401,18.439034 3.7156401,20.2872066 4.85307969,21.4317928 L6.56697354,23.1456867 C7.71077373,24.2850306 9.56051831,24.2850306 10.7043185,23.1456867 L14.5703622,19.279643 C14.9365407,18.9140991 15.1423111,18.4179341 15.1423111,17.900528 C15.1423111,17.3831219 14.9365407,16.8869569 14.5703622,16.521413 L14.4834066,16.4344575"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="10.2069328"
        y1="17.7927031"
        x2="17.7911957"
        y2="10.2067011"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolStackScroll = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-stack-scroll"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="4"
        y="9.71428571"
        width="14.2857143"
        height="14.2857143"
        rx="2"
      ></rect>
      <path
        d="M7.0094401,6.85714286 L18.9906762,6.85714286 C20.0952457,6.85714286 20.9906762,7.75257336 20.9906762,8.85714286 L20.9906762,21.1428571 L20.9906762,21.1428571"
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
      <path
        d="M9.71428571,4 L21.6955218,4 C22.8000913,4 23.6955218,4.8954305 23.6955218,6 L23.6955218,18.2857143 L23.6955218,18.2857143"
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export const ToolToggleDicomOverlay = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-toggle-dicom-overlay"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M21.5629346,19 C21.9081126,19 22.1879346,19.279822 22.1879346,19.625 C22.1879346,19.970178 21.9081126,20.25 21.5629346,20.25 L20.2129346,20.25 C19.8677566,20.25 19.5879346,19.970178 19.5879346,19.625 C19.5879346,19.279822 19.8677566,19 20.2129346,19 L21.5629346,19 Z M17.4829346,19 C17.8281125,19 18.1079346,19.279822 18.1079346,19.625 C18.1079346,19.970178 17.8281125,20.25 17.4829346,20.25 L16.1329346,20.25 C15.7877566,20.25 15.5079346,19.970178 15.5079346,19.625 C15.5079346,19.279822 15.7877566,19 16.1329346,19 L17.4829346,19 Z M13.4029345,19 C13.7481125,19 14.0279345,19.279822 14.0279345,19.625 C14.0279345,19.970178 13.7481125,20.25 13.4029345,20.25 L12.0529345,20.25 C11.7077565,20.25 11.4279345,19.970178 11.4279345,19.625 C11.4279345,19.279822 11.7077565,19 12.0529345,19 L13.4029345,19 Z M8.98988002,17.034041 C9.33501017,17.0282959 9.61945075,17.3034219 9.62519584,17.648552 C9.63057519,17.9717108 9.74731641,18.2750986 9.95299373,18.5163531 C10.1769336,18.7790292 10.1455318,19.1735095 9.88285564,19.3974494 C9.62017952,19.6213893 9.22569928,19.5899874 9.00175936,19.3273113 C8.60957687,18.8672907 8.38562164,18.2852745 8.37536899,17.6693568 C8.3696239,17.3242267 8.64474986,17.0397861 8.98988002,17.034041 Z M24,16.4185328 C24.345178,16.4185328 24.625,16.6983548 24.625,17.0435328 L24.625,17.625 C24.625,17.9681799 24.5587904,18.303203 24.431654,18.6151793 C24.3013887,18.9348335 23.936657,19.0883635 23.6170028,18.9580982 C23.2973486,18.8278329 23.1438186,18.4631012 23.2740839,18.143447 C23.3404391,17.9806197 23.375,17.8057405 23.375,17.625 L23.375,17.0435328 C23.375,16.6983548 23.654822,16.4185328 24,16.4185328 Z M9,12.9544019 C9.34517797,12.9544019 9.625,13.2342239 9.625,13.5794019 L9.625,14.9294019 C9.625,15.2745799 9.34517797,15.5544019 9,15.5544019 C8.65482203,15.5544019 8.375,15.2745799 8.375,14.9294019 L8.375,13.5794019 C8.375,13.2342239 8.65482203,12.9544019 9,12.9544019 Z M24,12.3385328 C24.345178,12.3385328 24.625,12.6183548 24.625,12.9635328 L24.625,14.3135328 C24.625,14.6587107 24.345178,14.9385328 24,14.9385328 C23.654822,14.9385328 23.375,14.6587107 23.375,14.3135328 L23.375,12.9635328 C23.375,12.6183548 23.654822,12.3385328 24,12.3385328 Z M9,8.87440184 C9.34517797,8.87440184 9.625,9.15422387 9.625,9.49940184 L9.625,10.8494019 C9.625,11.1945798 9.34517797,11.4744019 9,11.4744019 C8.65482203,11.4744019 8.375,11.1945798 8.375,10.8494019 L8.375,9.49940184 C8.375,9.15422387 8.65482203,8.87440184 9,8.87440184 Z M24,8.25853271 C24.345178,8.25853271 24.625,8.53835474 24.625,8.88353271 L24.625,10.2335327 C24.625,10.5787107 24.345178,10.8585327 24,10.8585327 C23.654822,10.8585327 23.375,10.5787107 23.375,10.2335327 L23.375,8.88353271 C23.375,8.53835474 23.654822,8.25853271 24,8.25853271 Z M8.85203131,5.11578232 C9.05066164,4.83348137 9.44053346,4.76565293 9.72283441,4.96428326 C10.0051354,5.16291358 10.0729638,5.55278541 9.87433347,5.83508635 C9.71277357,6.06470142 9.625,6.33744835 9.625,6.625 L9.625,6.76940182 C9.625,7.11457979 9.34517797,7.39440182 9,7.39440182 C8.65482203,7.39440182 8.375,7.11457979 8.375,6.76940182 L8.375,6.625 C8.375,6.07783578 8.54347711,5.55431124 8.85203131,5.11578232 Z M22.6742845,4.64042222 C22.8779596,4.36173907 23.2689882,4.30093301 23.5476713,4.50460808 C24.037257,4.86242093 24.3909544,5.3800285 24.5426114,5.97056314 C24.6284714,6.30489214 24.4270475,6.64552267 24.0927185,6.73138272 C23.7583895,6.81724277 23.417759,6.61581889 23.331899,6.28148989 C23.2527262,5.9732005 23.0672181,5.70172435 22.8100986,5.51380903 C22.5314155,5.31013396 22.4706094,4.91910536 22.6742845,4.64042222 Z M12.35,4 C12.695178,4 12.975,4.27982203 12.975,4.625 C12.975,4.97017797 12.695178,5.25 12.35,5.25 L11,5.25 C10.654822,5.25 10.375,4.97017797 10.375,4.625 C10.375,4.27982203 10.654822,4 11,4 L12.35,4 Z M16.4300001,4 C16.775178,4 17.0550001,4.27982203 17.0550001,4.625 C17.0550001,4.97017797 16.775178,5.25 16.4300001,5.25 L15.08,5.25 C14.7348221,5.25 14.455,4.97017797 14.455,4.625 C14.455,4.27982203 14.7348221,4 15.08,4 L16.4300001,4 Z M20.5100001,4 C20.8551781,4 21.1350001,4.27982203 21.1350001,4.625 C21.1350001,4.97017797 20.8551781,5.25 20.5100001,5.25 L19.1600001,5.25 C18.8148221,5.25 18.5350001,4.97017797 18.5350001,4.625 C18.5350001,4.27982203 18.8148221,4 19.1600001,4 L20.5100001,4 Z"
        id="Rectangle"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(16.5, 12.125) rotate(180) translate(-16.5, -12.125)"
      ></path>
      <path
        d="M6.1678365,9.125 L5.5,9.125 C4.3954305,9.125 3.5,10.0204305 3.5,11.125 L3.5,22.125 C3.5,23.2295695 4.3954305,24.125 5.5,24.125 L16.5,24.125 C17.6045695,24.125 18.5,23.2295695 18.5,22.125 L18.5,21.9543874 L18.5,21.9543874"
        id="Path-9"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export const ToolUltrasoundBidirectional = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-ultrasound-bidirectional"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <line
        x1="4"
        y1="17.5"
        x2="4"
        y2="23.5"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></line>
      <line
        x1="7.5"
        y1="20.5"
        x2="7.5"
        y2="26.5"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        transform="translate(7.5, 23.5) rotate(-90) translate(-7.5, -23.5)"
      ></line>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="4"
        cy="15.5"
        r="1.5"
      ></circle>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="12.5"
        cy="23.5"
        r="1.5"
      ></circle>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="8"
        y="4"
        width="17"
        height="10"
        rx="2"
      ></rect>
      <g
        id="US"
        transform="translate(11.6055, 6.5586)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path
          d="M2.15625,4.61328125 C1.49609375,4.61328125 1.05859375,4.21875 1.05859375,3.4921875 L1.05859375,0.109375 L0,0.109375 L0,3.6015625 C0,4.76953125 0.84375,5.54296875 2.15625,5.54296875 C3.46484375,5.54296875 4.30859375,4.76953125 4.30859375,3.6015625 L4.30859375,0.109375 L3.25,0.109375 L3.25,3.4921875 C3.25,4.21484375 2.8125,4.61328125 2.15625,4.61328125 Z"
          id="Path"
        ></path>
        <path
          d="M5.25390625,3.97265625 C5.30078125,4.81640625 5.95703125,5.54296875 7.3125,5.54296875 C8.6640625,5.54296875 9.42578125,4.859375 9.42578125,3.859375 C9.42578125,2.953125 8.85546875,2.5390625 7.9921875,2.34765625 L7.1640625,2.1640625 C6.6953125,2.06640625 6.43359375,1.86328125 6.43359375,1.546875 C6.43359375,1.1484375 6.78125,0.85546875 7.36328125,0.85546875 C7.9296875,0.85546875 8.27734375,1.1484375 8.34375,1.51953125 L9.34375,1.51953125 C9.29296875,0.6953125 8.58984375,0 7.37109375,0 C6.1953125,0 5.37890625,0.63671875 5.37890625,1.625 C5.37890625,2.44921875 5.90234375,2.91796875 6.73046875,3.10546875 L7.5546875,3.29296875 C8.109375,3.41796875 8.375,3.6015625 8.375,3.96484375 C8.375,4.38671875 8.02734375,4.6796875 7.37109375,4.6796875 C6.7421875,4.6796875 6.34375,4.375 6.2734375,3.97265625 L5.25390625,3.97265625 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export const ToolSegmentLabel = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M2.6636 14.3578C2.58841 14.4105 2.53094 14.4847 2.49878 14.5707C2.46661 14.6567 2.46127 14.7504 2.48345 14.8395C2.50564 14.9286 2.5543 15.0088 2.62302 15.0697C2.69175 15.1305 2.77731 15.1691 2.86842 15.1804L7.42867 16.5722L8.82125 21.1316C8.83209 21.2229 8.87047 21.3088 8.93131 21.3779C8.99214 21.4469 9.07254 21.4958 9.16181 21.518C9.25109 21.5402 9.34502 21.5348 9.43111 21.5023C9.5172 21.4699 9.59139 21.412 9.6438 21.3364L20.4127 10.5683C20.7607 10.1801 20.9661 9.68484 20.9951 9.16423L21 3.82256C21 3.6044 20.9133 3.39518 20.7591 3.24092C20.6048 3.08666 20.3956 3 20.1774 3H14.8382C14.3176 3.02823 13.8223 3.2334 13.4341 3.58155L2.6636 14.3578Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8882 8.75787C15.9796 8.75787 15.2431 8.02133 15.2431 7.11276C15.2431 6.20419 15.9796 5.46765 16.8882 5.46765C17.7968 5.46765 18.5333 6.20419 18.5333 7.11276C18.5333 8.02133 17.7968 8.75787 16.8882 8.75787Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ToolWindowLevel = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-window-level"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval-2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="14"
        cy="14"
        r="10"
      ></circle>
      <path
        d="M21.4837076,7.36702528 C23.0493155,9.13213184 24,11.4550438 24,14 C24,19.5228475 19.5228475,24 14,24 C11.4550438,24 9.13213184,23.0493155 7.36702528,21.4837076 Z"
        id="Combined-Shape"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);

export const ToolWindowRegion = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="tool-window-region"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M10.3460449,22 L4,22 C3.44771525,22 3,21.5522847 3,21 L3,4 C3,3.44771525 3.44771525,3 4,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,11.3197021"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <g
        id="Group"
        transform="translate(14, 15)"
        fill="currentColor"
      >
        <path
          d="M5.5,-0.75 C8.95177969,-0.75 11.75,2.04822031 11.75,5.5 C11.75,8.95177969 8.95177969,11.75 5.5,11.75 C2.04822031,11.75 -0.75,8.95177969 -0.75,5.5 C-0.75,2.04822031 2.04822031,-0.75 5.5,-0.75 Z M5.5,0.75 C2.87664744,0.75 0.75,2.87664744 0.75,5.5 C0.75,8.12335256 2.87664744,10.25 5.5,10.25 C8.12335256,10.25 10.25,8.12335256 10.25,5.5 C10.25,2.87664744 8.12335256,0.75 5.5,0.75 Z"
          id="Oval"
          fillRule="nonzero"
        ></path>
        <path
          d="M9.61552427,1.85128344 C10.4769151,2.82216322 11,4.09999509 11,5.5 C11,8.53756612 8.53756612,11 5.5,11 C4.09999509,11 2.82216322,10.4769151 1.85128344,9.61552427 Z"
          id="Combined-Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const ToolZoom = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <ellipse
        id="Oval-1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="11.5581395"
        cy="12.0909091"
        rx="7.81395349"
        ry="7.63636364"
      ></ellipse>
      <line
        x1="17.4186047"
        y1="17.8181818"
        x2="23.2790698"
        y2="23.5454545"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolBrush = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-brush"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M3.24640621,21.8286833 C3.09173375,21.7551472 2.99513748,21.5971513 3.00018895,21.4259625 C3.00524042,21.2547737 3.11098486,21.1027485 3.26972426,21.0384606 C5.3260304,20.2059201 4.66362518,17.8620247 5.27421252,16.6088957 C6.02197747,15.1026514 7.84114758,14.4766383 9.35746132,15.2037675 C13.9485253,17.4422999 8.48346644,24.3211232 3.24640621,21.8286833 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M21.5968442,2.302022 C21.1256527,1.8826075 20.4094461,1.90228142 19.9619901,2.34693083 L9.69255027,12.5887345 C11.0536437,13.0051578 12.1843437,13.9616637 12.8206229,15.2349008 L21.7410706,3.93687606 C22.1347378,3.44008272 22.0714081,2.72222021 21.5968442,2.302022 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolEraser = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-eraser"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M8.47826087,18.0030772 C7.48731947,17.9495317 6.54439458,17.5591084 5.80565217,16.8964685 L4.1066087,15.1958598 C3.49763625,14.5834856 3.49763625,13.5942339 4.1066087,12.9818598 L13.6317391,3.45672934 C14.2441133,2.84775689 15.233365,2.84775689 15.8457391,3.45672934 L19.8926087,7.5035989 C20.5015811,8.11597307 20.5015811,9.10522473 19.8926087,9.7175989 L12.7153043,16.8949033 C11.9769855,17.5579476 11.0343414,17.9489213 10.0434783,18.0030772 L8.47826087,18.0030772 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="10.0434783"
        y1="7.04499021"
        x2="16.3043478"
        y2="13.3058598"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="3"
        y1="20.5667293"
        x2="21"
        y2="20.5667293"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolThreshold = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-threshold"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <g
        id="Group"
        transform="translate(2.4184, 14.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16.5816327"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="12.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="14.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
      <g
        id="Group"
        transform="translate(11.7092, 7.4592) scale(-1, 1) translate(-11.7092, -7.4592)translate(1.9184, 5.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="11"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="13.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolShape = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="tool-seg-shape"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="16"
        cy="15"
        r="6"
      ></circle>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="3"
        y="3"
        width="13"
        height="13"
        rx="2"
      ></rect>
    </g>
  </svg>
);
export const ToolLabelmapAssist = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M15.896 11.3736L17.2416 8.6832L21.55 7.07903C21.9997 6.89305 22.3572 6.53602 22.5437 6.08648C22.7302 5.63693 22.7305 5.13171 22.5445 4.68195C22.3586 4.23219 22.0015 3.87473 21.552 3.6882C21.1025 3.50168 20.5972 3.50138 20.1475 3.68737L7.61663 9.14153L5.0573 7.8582C4.99771 7.82826 4.93231 7.81168 4.86566 7.80962C4.799 7.80756 4.7327 7.82007 4.67138 7.84628L2.27797 8.87295C2.20912 8.90242 2.14854 8.94832 2.10153 9.00662C2.05452 9.06493 2.02251 9.13386 2.00831 9.2074C1.99411 9.28093 1.99815 9.35683 2.02007 9.42844C2.04199 9.50006 2.08112 9.56521 2.13405 9.6182L5.56697 13.0511C5.63034 13.1145 5.71093 13.158 5.79875 13.1761C5.88657 13.1942 5.97777 13.1861 6.06105 13.1529L12.6583 10.5165"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0279 5.48134L10.0971 3.03476C9.98496 2.98841 9.85903 2.98841 9.74691 3.03476L7.557 3.94318C7.47321 3.97785 7.4016 4.03659 7.35121 4.11198C7.30082 4.18736 7.27393 4.276 7.27393 4.36668C7.27393 4.45735 7.30082 4.54599 7.35121 4.62137C7.4016 4.69676 7.47321 4.7555 7.557 4.79018L12.7123 6.92326"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0447 16.2917C18.0447 16.0585 17.9116 15.9187 17.6456 15.872C17.0203 15.7721 16.5315 15.6789 16.1789 15.5923C15.8264 15.4991 15.567 15.3658 15.4007 15.1927C15.2277 15.0195 15.1047 14.7664 15.0315 14.4334C14.9517 14.0937 14.8752 13.6241 14.802 13.0246C14.7821 12.9047 14.7355 12.8082 14.6624 12.7349C14.5825 12.6616 14.4894 12.625 14.383 12.625C14.2766 12.625 14.1835 12.6616 14.1036 12.7349C14.0238 12.8015 13.9739 12.8914 13.954 13.0047C13.8742 13.6174 13.7943 14.0903 13.7145 14.4234C13.628 14.7564 13.4983 15.0062 13.3254 15.1727C13.1458 15.3392 12.8831 15.4691 12.5372 15.5623C12.1847 15.6489 11.6991 15.7522 11.0805 15.872C10.9674 15.892 10.8776 15.942 10.8111 16.0219C10.7446 16.1018 10.7113 16.1918 10.7113 16.2917C10.7113 16.3982 10.7479 16.4915 10.8211 16.5714C10.8876 16.6447 10.9774 16.6913 11.0905 16.7113C11.6958 16.7979 12.1747 16.8811 12.5272 16.9611C12.8731 17.0343 13.1358 17.1575 13.3154 17.3307C13.495 17.4972 13.628 17.7537 13.7145 18.1C13.7943 18.453 13.8742 18.9426 13.954 19.5687C13.9739 19.6819 14.0238 19.7752 14.1036 19.8484C14.1768 19.9217 14.2699 19.9583 14.383 19.9583C14.4894 19.9583 14.5825 19.9184 14.6624 19.8384C14.7355 19.7652 14.7821 19.6719 14.802 19.5587C14.8752 18.9592 14.9517 18.493 15.0315 18.16C15.1047 17.8269 15.2277 17.5772 15.4007 17.4106C15.5736 17.2441 15.8397 17.1176 16.1989 17.031C16.5514 16.9377 17.0469 16.8312 17.6855 16.7113C17.7919 16.6913 17.8784 16.6413 17.9449 16.5614C18.0114 16.4815 18.0447 16.3916 18.0447 16.2917Z"
      fill="currentColor"
    />
    <path
      d="M12.5447 20.4167C12.5447 20.271 12.4615 20.1835 12.2952 20.1544C11.9045 20.092 11.5989 20.0337 11.3786 19.9796C11.1582 19.9213 10.9961 19.838 10.8922 19.7298C10.7841 19.6216 10.7072 19.4634 10.6615 19.2552C10.6116 19.0429 10.5638 18.7494 10.518 18.3748C10.5056 18.2998 10.4765 18.2395 10.4307 18.1937C10.3808 18.1479 10.3226 18.125 10.2561 18.125C10.1896 18.125 10.1314 18.1479 10.0815 18.1937C10.0316 18.2353 10.0005 18.2915 9.98799 18.3623C9.9381 18.7453 9.88822 19.0408 9.83833 19.249C9.78428 19.4571 9.70322 19.6132 9.59513 19.7173C9.48289 19.8214 9.31868 19.9026 9.1025 19.9608C8.88217 20.0149 8.57869 20.0795 8.19207 20.1544C8.1214 20.1669 8.06528 20.1981 8.0237 20.2481C7.98213 20.298 7.96134 20.3542 7.96134 20.4167C7.96134 20.4833 7.98421 20.5416 8.02994 20.5915C8.07151 20.6373 8.12763 20.6664 8.19831 20.6789C8.57661 20.733 8.87593 20.7851 9.09627 20.835C9.31244 20.8808 9.47665 20.9578 9.5889 21.0661C9.70114 21.1701 9.78428 21.3304 9.83833 21.5469C9.88822 21.7675 9.9381 22.0735 9.98799 22.4648C10.0005 22.5356 10.0316 22.5939 10.0815 22.6396C10.1273 22.6854 10.1855 22.7083 10.2561 22.7083C10.3226 22.7083 10.3808 22.6834 10.4307 22.6334C10.4765 22.5876 10.5056 22.5293 10.518 22.4586C10.5638 22.0839 10.6116 21.7925 10.6615 21.5844C10.7072 21.3762 10.7841 21.2201 10.8922 21.116C11.0003 21.012 11.1666 20.9329 11.391 20.8787C11.6114 20.8205 11.9211 20.7539 12.3202 20.6789C12.3867 20.6664 12.4407 20.6352 12.4823 20.5853C12.5239 20.5353 12.5447 20.4791 12.5447 20.4167Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolSegmentAnything = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12.5566 8.9332C12.5566 8.76203 12.459 8.65932 12.2636 8.62508C11.8045 8.55172 11.4455 8.48325 11.1867 8.41967C10.9278 8.3512 10.7373 8.25339 10.6152 8.12623C10.4882 7.99907 10.3979 7.81322 10.3441 7.56868C10.2855 7.31925 10.2294 6.97446 10.1756 6.53429C10.161 6.44626 10.1268 6.37534 10.0731 6.32154C10.0145 6.26774 9.94609 6.24084 9.86795 6.24084C9.7898 6.24084 9.72142 6.26774 9.66282 6.32154C9.60421 6.37045 9.56758 6.43647 9.55292 6.51962C9.49431 6.96957 9.4357 7.31681 9.3771 7.56135C9.3136 7.80588 9.21836 7.98929 9.09138 8.11156C8.95951 8.23382 8.76658 8.32919 8.51261 8.39766C8.25375 8.46124 7.89722 8.53705 7.44299 8.62508C7.35996 8.63976 7.29403 8.67644 7.24519 8.73513C7.19635 8.79381 7.17193 8.85984 7.17193 8.9332C7.17193 9.01145 7.19879 9.07992 7.25251 9.13861C7.30136 9.19241 7.36729 9.22665 7.45032 9.24132C7.89477 9.3049 8.24643 9.36603 8.50528 9.42472C8.75926 9.47852 8.95218 9.569 9.08405 9.69616C9.21592 9.81843 9.3136 10.0067 9.3771 10.261C9.4357 10.5202 9.49431 10.8797 9.55292 11.3394C9.56758 11.4226 9.60421 11.4911 9.66282 11.5449C9.71654 11.5987 9.78492 11.6256 9.86795 11.6256C9.94609 11.6256 10.0145 11.5962 10.0731 11.5375C10.1268 11.4837 10.161 11.4153 10.1756 11.3321C10.2294 10.8919 10.2855 10.5496 10.3441 10.3051C10.3979 10.0605 10.4882 9.87712 10.6152 9.75485C10.7422 9.63258 10.9376 9.53965 11.2013 9.47607C11.4602 9.4076 11.824 9.32935 12.2929 9.24132C12.371 9.22665 12.4345 9.18997 12.4834 9.13128C12.5322 9.07259 12.5566 9.00656 12.5566 8.9332Z"
      fill="currentColor"
    />
    <path
      d="M17.9415 13.8691C17.9415 13.6123 17.7949 13.4583 17.5019 13.4069C16.8132 13.2969 16.2748 13.1942 15.8865 13.0988C15.4982 12.9961 15.2125 12.8494 15.0293 12.6586C14.8388 12.4679 14.7033 12.1891 14.6227 11.8223C14.5348 11.4482 14.4506 10.931 14.37 10.2707C14.348 10.1387 14.2967 10.0323 14.2161 9.95161C14.1282 9.87092 14.0256 9.83057 13.9084 9.83057C13.7912 9.83057 13.6886 9.87092 13.6007 9.95161C13.5128 10.025 13.4579 10.124 13.4359 10.2487C13.348 10.9236 13.2601 11.4445 13.1722 11.8113C13.0769 12.1781 12.9341 12.4532 12.7436 12.6366C12.5458 12.82 12.2564 12.9631 11.8754 13.0658C11.4871 13.1612 10.9523 13.2749 10.271 13.4069C10.1465 13.4289 10.0476 13.484 9.97429 13.572C9.90103 13.66 9.8644 13.7591 9.8644 13.8691C9.8644 13.9865 9.90469 14.0892 9.98528 14.1772C10.0585 14.2579 10.1574 14.3093 10.282 14.3313C10.9487 14.4266 11.4761 14.5183 11.8644 14.6064C12.2454 14.6871 12.5348 14.8228 12.7326 15.0135C12.9304 15.1969 13.0769 15.4794 13.1722 15.8609C13.2601 16.2497 13.348 16.7889 13.4359 17.4785C13.4579 17.6032 13.5128 17.7059 13.6007 17.7866C13.6813 17.8673 13.7839 17.9076 13.9084 17.9076C14.0256 17.9076 14.1282 17.8636 14.2161 17.7756C14.2967 17.6949 14.348 17.5922 14.37 17.4675C14.4506 16.8072 14.5348 16.2937 14.6227 15.9269C14.7033 15.5601 14.8388 15.285 15.0293 15.1016C15.2198 14.9182 15.5129 14.7788 15.9085 14.6834C16.2967 14.5807 16.8425 14.4633 17.5459 14.3313C17.6631 14.3093 17.7583 14.2542 17.8316 14.1662C17.9048 14.0782 17.9415 13.9791 17.9415 13.8691Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3823 17.7373C19.0569 16.1757 20.044 14.1881 20.3223 12.1916C20.656 9.79757 20.2606 7.22773 18.7177 5.57321C17.0356 3.76929 14.2662 3.24208 11.6462 3.60868C9.83542 3.86207 8.02625 4.68764 6.52164 6.09072C4.92546 7.57918 3.9538 9.4548 3.62536 11.3563C3.21073 13.7569 3.82082 16.1818 5.47407 17.9547C7.20202 19.8077 9.72139 20.5742 12.2577 20.2193C14.0685 19.9659 15.8777 19.1403 17.3823 17.7373ZM21.8079 12.3987C21.4817 14.7386 20.3299 17.0396 18.4053 18.8343C16.6759 20.447 14.5823 21.4086 12.4656 21.7048C9.50415 22.1192 6.47736 21.23 4.37704 18.9777C2.36838 16.8236 1.66208 13.91 2.14725 11.101C2.5317 8.87524 3.66405 6.70447 5.49864 4.99369C7.22808 3.38096 9.32167 2.41934 11.4383 2.12316C14.3161 1.72048 17.6687 2.24881 19.8148 4.55022C21.7914 6.66994 22.1731 9.77848 21.8079 12.3987Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolPETSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M20.7108 20.7795C20.2638 20.7795 19.9924 20.4921 19.9924 20.0132V14.6703H18.4545C18.098 14.6703 17.8372 14.4148 17.8372 14.0689C17.8372 13.7177 18.098 13.4623 18.4545 13.4623H22.9724C23.3343 13.4623 23.5897 13.7124 23.5897 14.0689C23.5897 14.4202 23.3343 14.6703 22.9724 14.6703H21.4292V20.0132C21.4292 20.4868 21.1525 20.7795 20.7108 20.7795Z"
      fill="currentColor"
    />
    <path
      d="M12.8614 20.7795C12.4091 20.7795 12.1483 20.4921 12.1483 20.0025V14.5106C12.1483 13.755 12.4357 13.4623 13.186 13.4623H15.0219C16.5332 13.4623 17.507 14.4095 17.507 15.8464C17.507 17.347 16.5226 18.2357 14.9634 18.2357H13.5851V20.0025C13.5851 20.4921 13.319 20.7795 12.8614 20.7795ZM13.5851 17.1182H14.5057C15.6232 17.1182 16.0755 16.7936 16.0755 15.8676C16.0755 15.0694 15.6285 14.6117 14.841 14.6117H13.5851V17.1182Z"
      fill="currentColor"
    />
    <path
      d="M16.2855 10.7063C16.5677 8.68223 16.254 6.39013 14.8334 4.86666C13.2881 3.20953 10.8171 2.78346 8.59798 3.09398C7.01269 3.31581 5.43737 4.03721 4.13198 5.25454C2.74718 6.54592 1.89791 8.17926 1.61016 9.84527C1.24697 11.9481 1.77832 14.1031 3.25643 15.6882C4.80168 17.3453 7.04033 18.0136 9.25943 17.7031"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolInterpolation = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4 12.5H20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 2.5H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 21.5H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 7.5H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 16.5H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolBidirectionalSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.1853 15.6532L18.4009 8.77848"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.76544 7.91235L13.832 16.5978"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.14157 17.3088C2.76981 15.2751 2.67514 12.6925 3.6387 10.2811C4.4021 8.37067 5.82976 6.56762 7.81284 5.23002C9.6822 3.96912 12.3566 4.73828 14.311 4.67465C17.0466 4.58559 19.2925 3.97045 20.7266 6.09655C22.045 8.05118 20.748 11.3759 19.9013 13.7053C19.1692 15.7197 18.7965 17.0264 16.7161 18.4296C14.8467 19.6905 12.7787 20.3389 10.8244 20.4025C8.0887 20.4916 5.57565 19.4349 4.14157 17.3088Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
export const ToolExpand = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M19.9346 11.1104C19.7061 11.1104 19.5156 11.0342 19.3633 10.8818C19.2109 10.7236 19.1348 10.5273 19.1348 10.293V9.55469L19.3193 6.4873L16.999 8.92188L14.3008 11.6465C14.1543 11.7988 13.9668 11.875 13.7383 11.875C13.4922 11.875 13.2842 11.8018 13.1143 11.6553C12.9502 11.5029 12.8682 11.3037 12.8682 11.0576C12.8682 10.9404 12.8887 10.8291 12.9297 10.7236C12.9707 10.6182 13.0322 10.5273 13.1143 10.4512L15.8213 7.74414L18.2646 5.43262L15.1885 5.6084H14.4502C14.2158 5.6084 14.0195 5.53516 13.8613 5.38867C13.7031 5.23633 13.624 5.04297 13.624 4.80859C13.624 4.57422 13.7031 4.38086 13.8613 4.22852C14.0195 4.07617 14.2158 4 14.4502 4H19.3281C19.7793 4 20.1279 4.12598 20.374 4.37793C20.626 4.62402 20.752 4.96973 20.752 5.41504V10.293C20.752 10.5215 20.6729 10.7148 20.5146 10.873C20.3623 11.0312 20.1689 11.1104 19.9346 11.1104ZM10.293 20.7695H5.41504C4.96973 20.7695 4.62109 20.6436 4.36914 20.3916C4.12305 20.1455 4 19.7998 4 19.3545V14.4766C4 14.248 4.07617 14.0547 4.22852 13.8965C4.38086 13.7383 4.57422 13.6592 4.80859 13.6592C5.04297 13.6592 5.2334 13.7383 5.37988 13.8965C5.53223 14.0488 5.6084 14.2422 5.6084 14.4766V15.2148L5.43262 18.2822L7.74414 15.8477L10.4512 13.123C10.5977 12.9707 10.7822 12.8945 11.0049 12.8945C11.2568 12.8945 11.4648 12.9707 11.6289 13.123C11.793 13.2695 11.875 13.4658 11.875 13.7119C11.875 13.8291 11.8545 13.9404 11.8135 14.0459C11.7725 14.1514 11.7139 14.2422 11.6377 14.3184L8.92188 17.0254L6.4873 19.3369L9.56348 19.1611H10.293C10.5273 19.1611 10.7236 19.2344 10.8818 19.3809C11.04 19.5332 11.1191 19.7266 11.1191 19.9609C11.1191 20.1953 11.04 20.3887 10.8818 20.541C10.7295 20.6934 10.5332 20.7695 10.293 20.7695Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolContract = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M13.1162 5.08203C13.1162 4.84766 13.1924 4.65137 13.3447 4.49316C13.4971 4.33496 13.6904 4.25586 13.9248 4.25586C14.1592 4.25586 14.3496 4.33496 14.4961 4.49316C14.6484 4.65137 14.7246 4.84766 14.7246 5.08203V5.82031L14.5488 8.8877L16.8604 6.45312L19.5674 3.74609C19.6494 3.66406 19.7402 3.60254 19.8398 3.56152C19.9453 3.52051 20.0566 3.5 20.1738 3.5C20.4199 3.5 20.6191 3.58203 20.7715 3.74609C20.9238 3.91016 21 4.11816 21 4.37012C21 4.59277 20.9209 4.78027 20.7627 4.93262L18.0381 7.63086L15.6035 9.95117L18.6709 9.7666H19.4092C19.6436 9.7666 19.8369 9.83984 19.9893 9.98633C20.1475 10.1387 20.2266 10.332 20.2266 10.5664C20.2266 10.8008 20.1475 10.9941 19.9893 11.1465C19.8311 11.2988 19.6377 11.375 19.4092 11.375H14.54C14.0889 11.375 13.7373 11.252 13.4854 11.0059C13.2393 10.7598 13.1162 10.4111 13.1162 9.95996V5.08203ZM4.19531 13.5107C4.19531 13.2764 4.27441 13.083 4.43262 12.9307C4.58496 12.7783 4.77832 12.7021 5.0127 12.7021H9.97852C10.4297 12.7021 10.7783 12.8252 11.0244 13.0713C11.2705 13.3174 11.3936 13.666 11.3936 14.1172V19.0918C11.3936 19.3262 11.3174 19.5225 11.165 19.6807C11.0186 19.8389 10.8252 19.918 10.585 19.918C10.3506 19.918 10.1602 19.8389 10.0137 19.6807C9.86719 19.5225 9.79395 19.3262 9.79395 19.0918V18.2568L9.96973 15.1807L7.6582 17.624L4.88965 20.3926C4.80762 20.4688 4.7168 20.5273 4.61719 20.5684C4.51172 20.6094 4.40039 20.6299 4.2832 20.6299C4.03711 20.6299 3.83789 20.5479 3.68555 20.3838C3.5332 20.2197 3.45703 20.0146 3.45703 19.7686C3.45703 19.54 3.53613 19.3525 3.69434 19.2061L6.47168 16.4463L8.90625 14.126L5.84766 14.3105H5.0127C4.77832 14.3105 4.58496 14.2344 4.43262 14.082C4.27441 13.9297 4.19531 13.7393 4.19531 13.5107Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolAnatomicalHeart = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 21.35l-1.32-1.18C5.62 15.65 2.25 12.64 2.25 8.94 2.25 5.92 4.58 3.6 7.56 3.6c1.68 0 3.29.78 4.44 2.02A5.98 5.98 0 0 1 16.44 3.6c2.98 0 5.31 2.32 5.31 5.34 0 3.7-3.37 6.71-8.43 11.23L12 21.35z" />
  </svg>
);
export const ToolBloodVessel = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 100 100"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M84.65552,38.39482a6.38753,6.38753,0,0,1-3.82585-2.09316A20.96291,20.96291,0,0,0,85.40826,31.368a1,1,0,1,0-1.63438-1.15274c-4.917,6.97178-8.192,6.2542-11.98408,5.42325a18.44457,18.44457,0,0,0-4.492-.59278c.01453-.36982.025-.7438.02763-1.12558.05459-8.108,12.03017-13.08565,12.18017-13.147l.00049-.00019.033-.01416c2.01953-.90635,1.47-4.59316.10478-7.63516-1.34962-3.00732-3.70028-5.83593-5.70471-5.0238C61.86956,12.473,60.06265,27.1377,59.79654,31.52842c-.28994,4.78447-2.0333,8.2039-5.32246,10.42461A33.43409,33.43409,0,0,1,48.10364,28.6634c3.61707-3.08586,4.8878-8.00351,5.24581-12.1926.85053-1.50146,3.18-4.97993,5.503-6.03672a1,1,0,0,0-.82813-1.82051,13.33925,13.33925,0,0,0-4.56543,4.08775,32.23588,32.23588,0,0,0-.32939-4.0312,1,1,0,0,0-1.97461.31767c.01981.12408,1.7902,11.67251-3.56,17.39944a52.87537,52.87537,0,0,1-.79671-5.69641,59.42171,59.42171,0,0,1,.22237-12.50674,1.00058,1.00058,0,0,0-.24561-.81982C46.65845,7.23506,43.883,4.2,40.29039,4.2a14.62528,14.62528,0,0,0-6.085,1.35107.99966.99966,0,0,0-.40655.38086c-1.353,2.27911-.80029,10.21924-.38554,14.47911a26.6391,26.6391,0,0,0-15.80039-5.209c-2.20147,0-3.20411,3.65156-3.20411,7.04434,0,2.75743.82958,7.48076,3.52828,7.0145,7.51209.321,16.95919,6.35117,18.32866,10.52309,3.01338,9.18,8.52353,14.689,13.85215,20.01641a8.82325,8.82325,0,0,1,1.89968,2.6052,15.91836,15.91836,0,0,0-8.16326-.89319c-6.40117.6667-9.64795-.909-11.24453-2.34785a6.19769,6.19769,0,0,1-2.09-4.6501,1,1,0,0,0-2,0,8.174,8.174,0,0,0,2.75108,6.13575,10.36675,10.36675,0,0,0,3.09792,1.88833c-2.21907,1.51694-6.40246,1.79516-8.08279,1.75434a1,1,0,0,0-.04922,1.99942c3.21738.07857,8.15587-.5841,10.36991-3.06885a23.30445,23.30445,0,0,0,7.4549.27822c5.25391-.547,7.75156.7416,8.92168,1.919.01728.01739.03739.02984.0556.04568,1.92608,9.22727-3.47507,23.27874-3.90034,24.36135a2.67154,2.67154,0,0,0-.45868,1.48926c0,2.91182,4.69209,4.483,9.10684,4.483,3.4649,0,7.09956-.96826,8.50363-2.79243,4.29081-4.94038,2.8361-15.43511.84607-23.40171a91.00574,91.00574,0,0,0-6.20283-17.51035c1.50637-1.6301,5.37558-6.574,6.22415-15.04265a15.99467,15.99467,0,0,1,4.204.53923A18.75019,18.75019,0,0,0,75.388,38.171a8.47916,8.47916,0,0,0,3.68587-.81609,8.649,8.649,0,0,0,5.45271,3.03581q.033.00205.06543.002a1,1,0,0,0,.06347-1.99795ZM74.69478,9.96455c.44512.06133,1.89346,1.235,3.12451,3.978,1.23116,2.74326,1.14512,4.60537.895,4.97851-.44511-.06142-1.89345-1.235-3.12451-3.978C74.35865,12.1998,74.44468,10.3377,74.69478,9.96455ZM17.613,27.26885c-.38457-.28164-1.20411-1.99571-1.20411-5.02246s.81954-4.74073,1.20411-5.02237c.38457.28164,1.2041,1.99571,1.2041,5.02237S17.99752,26.98721,17.613,27.26885ZM57.78668,93.8c-4.27237,0-7.10684-1.49453-7.10684-2.483s2.83447-2.483,7.10684-2.483,7.10683,1.49454,7.10683,2.483a.87382.87382,0,0,1-.182.46328C64.02518,92.71326,61.42958,93.8,57.78668,93.8Zm1.09775-41.236c.70752.90586,4.07275,8.56436,6.31152,17.52657,2.15789,8.63811,2.45677,15.32793.91509,19.32075-1.51579-1.68506-4.99829-2.5773-8.32436-2.5773a16.62445,16.62445,0,0,0-5.78439.97613c8.01216-23.55795-.44971-29.248-.4703-29.42407C46.1316,52.98682,41.03062,47.88691,38.166,39.16016c-1.70689-5.19964-11.22106-10.70489-18.2978-11.72063a12.96178,12.96178,0,0,0,.94888-5.19314,13.40084,13.40084,0,0,0-.848-4.967c7.8802.698,13.956,6.05108,14.02168,6.10977a1.00083,1.00083,0,0,0,1.66113-.86182c-.5792-4.882-1.12734-13.11074-.25332-15.32412A12.8994,12.8994,0,0,1,40.29039,6.2a7.53,7.53,0,0,1,4.684,2.19121,62.14925,62.14925,0,0,0-.17314,12.42129c.70135,8.25362,3.19818,16.868,8.72617,23.10928a1.00013,1.00013,0,0,0,1.25478.19951c4.30342-2.52549,6.66221-6.72168,7.01065-12.47188.23093-3.80874,1.68926-15.92329,10.75051-20.74624A12.81341,12.81341,0,0,0,73.76519,15.762a12.74232,12.74232,0,0,0,2.84942,4.16873c-3.78726,1.97378-11.24057,6.771-11.28916,13.9759-.07744,11.50361-6.26036,17.24268-6.321,17.29766A1,1,0,0,0,58.88443,52.564Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
  </svg>
);
export const ToolSculptor = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M16.5 1.5C19.2614 1.5 21.5 3.73858 21.5 6.5C21.5 8.59844 20.2065 10.3931 18.374 11.1348C18.4555 11.5776 18.5 12.0336 18.5 12.5C18.5 16.6421 15.1421 20 11 20C10.6311 20 10.4428 19.5684 10.6035 19.2363C10.8575 18.7113 11 18.1224 11 17.5C11 15.2909 9.20914 13.5 7 13.5C6.07751 13.5 5.22759 13.8124 4.55078 14.3369C4.24235 14.5757 3.75506 14.4797 3.67188 14.0986C3.55945 13.5836 3.5 13.0488 3.5 12.5C3.5 8.35786 6.85786 5 11 5C11.2421 5 11.4815 5.01272 11.7178 5.03516C12.3439 2.98844 14.2482 1.5 16.5 1.5ZM16.4707 3.53125C16.1133 3.53125 15.8906 3.7832 15.8906 4.14648V6.07422H14.0684C13.7109 6.07422 13.4648 6.29688 13.4648 6.64844C13.4648 7 13.7109 7.2168 14.0684 7.2168H15.8906V9.13867C15.8906 9.50195 16.1133 9.75391 16.4707 9.75391C16.8223 9.75391 17.0449 9.50195 17.0449 9.13867V7.2168H18.8613C19.2188 7.2168 19.4707 7 19.4707 6.64844C19.4707 6.29688 19.2188 6.07422 18.8613 6.07422H17.0449V4.14648C17.0449 3.7832 16.8223 3.53125 16.4707 3.53125Z"
      fill="currentColor"
    />
    <path
      d="M5.69531 18.1406C5.34375 18.1406 5.08594 17.9238 5.08594 17.5664C5.08594 17.2148 5.34375 16.998 5.69531 16.998H8.50195C8.85352 16.998 9.11719 17.2148 9.11719 17.5664C9.11719 17.9238 8.85352 18.1406 8.50195 18.1406H5.69531Z"
      fill="currentColor"
    />
    <circle
      cx="7"
      cy="17.5"
      r="4.5"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolLabelmapEditWithContour = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M10.3945 12.6113C10.043 12.6113 9.78516 12.3945 9.78516 12.0371C9.78516 11.6855 10.043 11.4688 10.3945 11.4688H13.2012C13.5527 11.4688 13.8164 11.6855 13.8164 12.0371C13.8164 12.3945 13.5527 12.6113 13.2012 12.6113H10.3945Z"
      fill="currentColor"
    />
    <path
      opacity="0.5"
      d="M18.312 6.84473C21.8473 8.88583 22.9225 13.6424 20.7134 17.4687C18.5042 21.2951 13.8473 22.7422 10.312 20.7011C9.51661 20.2419 8.84737 19.6439 8.31042 18.9512C11.3012 19.3598 14.4827 17.8251 16.1946 14.8598C17.9067 11.8945 17.6457 8.3712 15.7963 5.98538C16.6645 6.10409 17.5167 6.38556 18.312 6.84473Z"
      fill="currentColor"
    />
    <circle
      cx="13.7852"
      cy="13.4688"
      r="8"
      stroke="currentColor"
    />
    <path
      d="M4.50586 8.22266C4.14844 8.22266 3.92578 7.9707 3.92578 7.60742V5.68555H2.10352C1.74609 5.68555 1.5 5.46875 1.5 5.11719C1.5 4.76562 1.74609 4.54297 2.10352 4.54297H3.92578V2.61523C3.92578 2.25195 4.14844 2 4.50586 2C4.85742 2 5.08008 2.25195 5.08008 2.61523V4.54297H6.89648C7.25391 4.54297 7.50586 4.76562 7.50586 5.11719C7.50586 5.46875 7.25391 5.68555 6.89648 5.68555H5.08008V7.60742C5.08008 7.9707 4.85742 8.22266 4.50586 8.22266Z"
      fill="currentColor"
    />
  </svg>
);
